import { dataQACommentSolid, dataAbTest, dataAbTestSolid, dataAbstract, dataAbstractSolid, dataAcademicCap, dataAcademicCapSolid, dataAdDeliveryCircleSolid, dataAddPauseSquare, dataAdjust, dataAfterSquare, dataAfterSquareSolid, dataAi, dataAiBubble, dataAiBubbleSolid, dataAlignBottom, dataAlignCenter, dataAlignLeft, dataAlignRight, dataAlignTop, dataAndroid, dataAnticlockwise, dataAppStore, dataApps, dataAppsSettings, dataAppsSettingsSolid, dataAppsSolid, dataArrowCurveDownRightSolid, dataArrowCurveUpRightSolid, dataArrowDown, dataArrowDownLeft, dataArrowDownRight, dataArrowDownSolid, dataArrowLeft, dataArrowLeftSolid, dataArrowRight, dataArrowRightSolid, dataArrowToBottom, dataArrowToTop, dataArrowToTopSoild, dataArrowToTopSolid, dataArrowUUpLeft, dataArrowUUpRight, dataArrowUp, dataArrowUpSolid, dataAsterisk, dataAttribute, dataAttributeSolid, dataAudio, dataAudioSolid, dataBabyBottle, dataBabyBottleSolid, dataBackground, dataBackgroundSolid, dataBackgroundSwitchSolid, dataBarChart, dataBarChartAlt, dataBarChartAltSolid, dataBarChartSolid, dataBarChartSquare, dataBarChartSquareSolid, dataBeforeSquare, dataBeforeSquareSolid, dataBell, dataBellSolid, dataBold, dataBook, dataBookBookmark, dataBookBookmarkCheckSolid, dataBookBookmarkSolid, dataBookOpen, dataBookSolid, dataBookmark, dataBookmarkSolid, dataBooksBookmark, dataBooksBookmarkSolid, dataBox, dataBoxSolid, dataBrush, dataBuilding, dataBuildingSolid, dataBulb, dataBulbDash, dataBulbDashSolid, dataBulbSolid, dataBulbTrendSolid, dataBullseye, dataBullseyeHit, dataBullseyeHitSolid, dataCalendar, dataCalendarCny, dataCalendarCnySolid, dataCalendarHeart, dataCalendarHeartSolid, dataCalendarSolid, dataCamera, dataCameraAdd, dataCameraAddSolid, dataCameraSolid, dataCar, dataCarSolid, dataCardSolid, dataCaretDown, dataCaretLeft, dataCaretRight, dataCaretUp, dataCaretsOpposite, dataCellphone, dataCellphoneSolid, dataChat, dataChatSolid, dataCheck, dataCheckCircle, dataCheckCircleSolid, dataCheckDesktop, dataCheckDesktopSolid, dataCheckSquare, dataCheckSquareSolid, dataChevronDoubleDown, dataChevronDoubleLeft, dataChevronDoubleRight, dataChevronDoubleUp, dataChevronDown, dataChevronLeft, dataChevronLeftCircle, dataChevronLeftCircleSolid, dataChevronRight, dataChevronRightCircle, dataChevronRightCircleSolid, dataChevronUp, dataCircleExtend, dataCircleExtendSolid, dataCircleRotation, dataCircleRotationSolid, dataClock, dataClockSolid, dataClockwise, dataCloudUploadSolid, dataCnyCircle, dataCnyCircleSolid, dataCnyRefund, dataCnyWallet, dataCnyWalletSolid, dataCoin, dataCoinDiamond, dataCoinDiamondSolid, dataCoinSolid, dataColorPalette, dataColorPaletteSolid, dataCompass, dataCompassSolid, dataComponent, dataComponentSolid, dataCopy, dataCopySolid, dataCouponMinus, dataCouponMinusSolid, dataCouponPercent, dataCouponPercentSolid, dataCrop, dataCropSolid, dataCrown, dataCrownSolid, dataCube, dataCubeEye, dataCubeEyeSolid, dataCubeSolid, dataCurveSquare, dataCurveSquareSolid, dataCustomer, dataCustomerService, dataCustomerSettings, dataCustomerSettingsSolid, dataCustomerSolid, dataCut, dataCutSolid, dataData, dataDataMarket, dataDataMarketSolid, dataDataSolid, dataDatabase, dataDatabaseSolid, dataDecreaseWidth, dataDesktop, dataDesktopSolid, dataDetailList, dataDetailListSolid, dataDiamond, dataDiamondSolid, dataDollarCircle, dataDollarCircleSolid, dataDoubleCircle, dataDoubleCircleSolid, dataDownload, dataDragIndicator, dataEdit, dataEditSolid, dataElement, dataElementSolid, dataEllipsis, dataEllipsisCircle, dataEllipsisCircleSolid, dataEllipsisVertical, dataEnglishComment, dataEnglishCommentSolid, dataEnvelope, dataEnvelopeOpen, dataEnvelopeOpenSolid, dataEnvelopeSolid, dataExcellentBookmark, dataExcellentBookmarkSolid, dataExclamationCircle, dataExclamationCircleSolid, dataExclamationTriangle, dataExclamationTriangleSolid, dataExpand, dataExpandAlt, dataExpandSquare, dataExpandSquareSolid, dataExternalLink, dataEye, dataEyeBright, dataEyeBrightSolid, dataEyeSlash, dataEyeSlashSolid, dataEyeSolid, dataEyeTracking, dataEyeTrackingSolid, dataEyedropper, dataFastForward, dataFastRewind, dataFeed, dataFeedSolid, dataFeedbackSolid, dataFile, dataFileAdd, dataFileAddSolid, dataFileEdit, dataFileEditSolid, dataFileError, dataFileErrorSolid, dataFileSolid, dataFilm, dataFilmSolid, dataFilter, dataFilterSolid, dataFireSolid, dataFitWidth, dataFlag, dataFlagSolid, dataFolder, dataFolderDownload, dataFolderDownloadSolid, dataFolderOpen, dataFolderOpenSolid, dataFolderSolid, dataFont, dataFontSize, dataFourDots, dataFourQuarterCircles, dataFourQuarterCirclesSolid, dataFrowningFace, dataFrowningFaceSolid, dataFullCircle, dataFullCircleSolid, dataFullscreen, dataFullscreenExit, dataGallery, dataGallerySolid, dataGamepad, dataGamepadSolid, dataGateway, dataGatewaySolid, dataGift, dataGiftSolid, dataGirl, dataGirlSolid, dataGradeCircle, dataGradeCircleSolid, dataHamburger, dataHammerSolid, dataHeadphones, dataHeadphonesSolid, dataHeart, dataHeartCancel, dataHeartCancelSolid, dataHeartHandshakeSolid, dataHeartSolid, dataHeteronymSquare, dataHexagonSolid, dataHierarchy, dataHierarchySolid, dataHighSquare, dataHighSquareSolid, dataHome, dataHomeAltSolid, dataHomeSolid, dataHospital, dataHospitalSolid, dataHourglass, dataHourglassSolid, dataHouse, dataHouseSolid, dataIdCard, dataIdCardBack, dataIdCardBackSolid, dataIdCardSolid, dataIdCircle, dataIdSquare, dataImage, dataImageAdd, dataImageDesktopSolid, dataImageSolid, dataImageStar, dataImageStarSolid, dataImageUpload, dataImport, dataIndent, dataInfoCircle, dataInfoCircleSolid, dataInfoflow, dataIntelligence, dataIntelligenceSolid, dataIntelligentPrompt, dataInvoice, dataInvoiceSolid, dataItalic, dataKeyCommand, dataKeyDelete, dataKeyShift, dataKeyboard, dataLandingPageSolid, dataLayer, dataLayerSolid, dataLayout, dataLayoutSolid, dataLetterSpacing, dataLightning, dataLightningSolid, dataLineChart, dataLineChartAlt, dataLineChartAltSolid, dataLineChartSolid, dataLineHeight, dataLink, dataLinkAlt, dataLinkAltSolid, dataListChecked, dataListOrdered, dataListUnordered, dataLoading, dataLocation, dataLocationCopy, dataLocationCopySolid, dataLocationPin, dataLocationPinSolid, dataLocationSolid, dataLock, dataLockSolid, dataLongVideo, dataLongVideoSolid, dataLowSquare, dataLowSquareSolid, dataMagicWand, dataMagicWandSolid, dataMagnet, dataMagnetSolid, dataMarket, dataMarketSolid, dataMediaAdd, dataMedicalKit, dataMedicalKitSolid, dataMediumSquare, dataMediumSquareSolid, dataMenu, dataMigrate, dataMigrateSolid, dataMiniAppBaidu, dataMiniAppBaiduSolid, dataMiniAppWechat, dataMinimize, dataMinus, dataMinusCircle, dataMinusCircleSolid, dataMobileApp, dataMobileAppSolid, dataMotionGraphics, dataMove, dataMovieSolid, dataMusic, dataMusicSolid, dataMute, dataMuteSolid, dataNeutralFace, dataNeutralFaceSolid, dataOneToOne, dataOneToOneSolid, dataOrder, dataOrderSolid, dataOutdent, dataOutstanding, dataOutstandingSolid, dataPackageUpload, dataPackageUploadSolid, dataPaintBucket, dataPaintBucketSolid, dataPaperClip, dataPaperPlane, dataPaperPlaneSend, dataPaperPlaneSendSolid, dataPaperPlaneSolid, dataPaste, dataPasteImageSolid, dataPasteSolid, dataPath, dataPathSolid, dataPause, dataPauseCircle, dataPauseCircleSolid, dataPenWrite, dataPenWriteSolid, dataPencil, dataPencilSolid, dataPhone, dataPhoneCall, dataPhoneCallSolid, dataPhoneEye, dataPhoneEyeSolid, dataPhoneSolid, dataPieChart, dataPieChartSolid, dataPinSlant, dataPinSolid, dataPlay, dataPlayCircle, dataPlayCircleSolid, dataPlus, dataPlusCircle, dataPlusCircleSolid, dataPlusSquare, dataPlusSquareSolid, dataPowerOff, dataPrinterSolid, dataPuzzlePiece, dataPuzzlePieceSolid, dataPvShield, dataPvShieldSolid, dataQrcode, dataQualityCircle, dataQualityCircleSolid, dataQuestionCircle, dataQuestionCircleSolid, dataQuestionComment, dataQuestionCommentSolid, dataRecommendSquare, dataRecommendSquareSolid, dataRecommendation, dataRedo, dataRedoSolid, dataReport, dataReportBookmark, dataReportBookmarkSolid, dataReportCheck, dataReportCheckSolid, dataReportSearch, dataReportSearchSolid, dataReportSettings, dataReportSettingsSolid, dataReportSolid, dataReportStamp, dataReportStampSolid, dataReportStar, dataReportStarSolid, dataReportTrendSettings, dataReportTrendSettingsSolid, dataReportUser, dataReportUserSolid, dataRoad, dataRocketSolid, dataRotateAnticlockwise, dataRotateAnticlockwiseSolid, dataRotateClockwise, dataRotateClockwiseSolid, dataSave, dataSaveSolid, dataScan, dataSearch, dataSearchDesktop, dataSearchDesktopSolid, dataSearchHistory, dataSearchHistorySolid, dataSearchSolid, dataSettings, dataSettingsSolid, dataShare, dataShareAlt, dataShareAltSolid, dataShieldCheck, dataShieldCheckSolid, dataShieldCnySolid, dataShieldEllipsisSolid, dataShieldTimesSolid, dataShieldUser, dataShieldUserSolid, dataShieldWave, dataShieldWaveSolid, dataShoppingBag, dataShoppingBagSolid, dataShoppingCart, dataShoppingCartSolid, dataShortVideo, dataShortVideoSolid, dataShrink, dataSignOut, dataSkipBackward, dataSkipForward, dataSlidersSquare, dataSlidersSquareSolid, dataSmiley, dataSmileyComment, dataSmileySolid, dataSmileyStar, dataSmileyStarSolid, dataSort, dataSortAlt, dataSortAsc, dataSortDesc, dataSoundWave, dataSparklesSolid, dataSplit, dataSquareRotation, dataSquareRotationSolid, dataStamp, dataStampSolid, dataStar, dataStarDash, dataStarDashSoild, dataStarDashSolid, dataStarHalf, dataStarSolid, dataStop, dataStopSolid, dataStrikethrough, dataSwitch, dataSync, dataSyncCircle, dataSyringe, dataSyringesSolid, dataTag, dataTagSolid, dataTeam, dataTeamSolid, dataTelephone, dataTelephoneSolid, dataTemplate, dataTemplateSolid, dataTextFlowerSquare, dataTextFlowerSquareSolid, dataTextSquare, dataTextSquareAltSolid, dataTextSquareSolid, dataThumbDown, dataThumbDownSolid, dataThumbUp, dataThumbUpSolid, dataTimes, dataTimesCircle, dataTimesCircleSolid, dataToolbox, dataToolboxSolid, dataToolsSolid, dataTrackCut, dataTrackFrameLast, dataTrash, dataTrashSolid, dataTravelEarthPlaneSolid, dataTreasureChest, dataTreasureChestSolid, dataTrendDesktop, dataTrendDesktopSolid, dataTrendMonitor, dataTrendMonitorSolid, dataTrendPages, dataTrendPagesSolid, dataTrendReport, dataTrendReportSolid, dataTrendStarSolid, dataTrimLeft, dataTrimRight, dataTrophy, dataTrophySolid, dataTruck, dataTruckSolid, dataTv, dataTvSolid, dataTwoHearts, dataTwoHeartsSolid, dataUnderline, dataUndo, dataUndoSolid, dataUnlink, dataUnlock, dataUnlockSolid, dataUpdateWave, dataUpgrade, dataUpgradeSolid, dataUpload, dataUploadDesktop, dataUploadDesktopSolid, dataUser, dataUserAuthorization, dataUserBookmark, dataUserBookmarkSolid, dataUserCard, dataUserCardSolid, dataUserCircle, dataUserCircleSolid, dataUserCombined, dataUserCombinedSolid, dataUserFilter, dataUserFilterSolid, dataUserIntersection, dataUserIntersectionSolid, dataUserLabel, dataUserLabelSolid, dataUserMobile, dataUserMobileSolid, dataUserSearch, dataUserSearchSolid, dataUserSettings, dataUserSettingsSolid, dataUserSolid, dataUserStar, dataUserSync, dataUserSyncSolid, dataUserTieba, dataVideo, dataVideoAdd, dataVideoCrop, dataVideoCropSolid, dataVideoFilm, dataVideoFilmSolid, dataVideoFrameFirst, dataVideoHistory, dataVideoHistorySolid, dataVideoSolid, dataVideoUpload, dataVolume, dataVolumeSolid, dataWhirlpool, dataWhirlpoolSolid, dataWoman, dataYaoSquare, dataYingxiaotong, dataYingxiaotongSolid, dataZoomIn, dataZoomInSolid, dataZoomOut, dataZoomOutSolid } from 'dls-icons-data';
export { dataAbTest, dataAbTestSolid, dataAbstract, dataAbstractSolid, dataAcademicCap, dataAcademicCapSolid, dataAdDeliveryCircleSolid, dataAddPauseSquare, dataAdjust, dataAfterSquare, dataAfterSquareSolid, dataAi, dataAiBubble, dataAiBubbleSolid, dataAlignBottom, dataAlignCenter, dataAlignLeft, dataAlignRight, dataAlignTop, dataAndroid, dataAnticlockwise, dataAppStore, dataApps, dataAppsSettings, dataAppsSettingsSolid, dataAppsSolid, dataArrowCurveDownRightSolid, dataArrowCurveUpRightSolid, dataArrowDown, dataArrowDownLeft, dataArrowDownRight, dataArrowDownSolid, dataArrowLeft, dataArrowLeftSolid, dataArrowRight, dataArrowRightSolid, dataArrowToBottom, dataArrowToTop, dataArrowToTopSoild, dataArrowToTopSolid, dataArrowUUpLeft, dataArrowUUpRight, dataArrowUp, dataArrowUpSolid, dataAsterisk, dataAttribute, dataAttributeSolid, dataAudio, dataAudioSolid, dataBabyBottle, dataBabyBottleSolid, dataBackground, dataBackgroundSolid, dataBackgroundSwitchSolid, dataBarChart, dataBarChartAlt, dataBarChartAltSolid, dataBarChartSolid, dataBarChartSquare, dataBarChartSquareSolid, dataBeforeSquare, dataBeforeSquareSolid, dataBell, dataBellSolid, dataBold, dataBook, dataBookBookmark, dataBookBookmarkCheckSolid, dataBookBookmarkSolid, dataBookOpen, dataBookSolid, dataBookmark, dataBookmarkSolid, dataBooksBookmark, dataBooksBookmarkSolid, dataBox, dataBoxSolid, dataBrush, dataBuilding, dataBuildingSolid, dataBulb, dataBulbDash, dataBulbDashSolid, dataBulbSolid, dataBulbTrendSolid, dataBullseye, dataBullseyeHit, dataBullseyeHitSolid, dataCalendar, dataCalendarCny, dataCalendarCnySolid, dataCalendarHeart, dataCalendarHeartSolid, dataCalendarSolid, dataCamera, dataCameraAdd, dataCameraAddSolid, dataCameraSolid, dataCar, dataCarSolid, dataCardSolid, dataCaretDown, dataCaretLeft, dataCaretRight, dataCaretUp, dataCaretsOpposite, dataCellphone, dataCellphoneSolid, dataChat, dataChatSolid, dataCheck, dataCheckCircle, dataCheckCircleSolid, dataCheckDesktop, dataCheckDesktopSolid, dataCheckSquare, dataCheckSquareSolid, dataChevronDoubleDown, dataChevronDoubleLeft, dataChevronDoubleRight, dataChevronDoubleUp, dataChevronDown, dataChevronLeft, dataChevronLeftCircle, dataChevronLeftCircleSolid, dataChevronRight, dataChevronRightCircle, dataChevronRightCircleSolid, dataChevronUp, dataCircleExtend, dataCircleExtendSolid, dataCircleRotation, dataCircleRotationSolid, dataClock, dataClockSolid, dataClockwise, dataCloudUploadSolid, dataCnyCircle, dataCnyCircleSolid, dataCnyRefund, dataCnyWallet, dataCnyWalletSolid, dataCoin, dataCoinDiamond, dataCoinDiamondSolid, dataCoinSolid, dataColorPalette, dataColorPaletteSolid, dataCompass, dataCompassSolid, dataComponent, dataComponentSolid, dataCopy, dataCopySolid, dataCouponMinus, dataCouponMinusSolid, dataCouponPercent, dataCouponPercentSolid, dataCrop, dataCropSolid, dataCrown, dataCrownSolid, dataCube, dataCubeEye, dataCubeEyeSolid, dataCubeSolid, dataCurveSquare, dataCurveSquareSolid, dataCustomer, dataCustomerService, dataCustomerSettings, dataCustomerSettingsSolid, dataCustomerSolid, dataCut, dataCutSolid, dataData, dataDataMarket, dataDataMarketSolid, dataDataSolid, dataDatabase, dataDatabaseSolid, dataDecreaseWidth, dataDesktop, dataDesktopSolid, dataDetailList, dataDetailListSolid, dataDiamond, dataDiamondSolid, dataDollarCircle, dataDollarCircleSolid, dataDoubleCircle, dataDoubleCircleSolid, dataDownload, dataDragIndicator, dataEdit, dataEditSolid, dataElement, dataElementSolid, dataEllipsis, dataEllipsisCircle, dataEllipsisCircleSolid, dataEllipsisVertical, dataEnglishComment, dataEnglishCommentSolid, dataEnvelope, dataEnvelopeOpen, dataEnvelopeOpenSolid, dataEnvelopeSolid, dataExcellentBookmark, dataExcellentBookmarkSolid, dataExclamationCircle, dataExclamationCircleSolid, dataExclamationTriangle, dataExclamationTriangleSolid, dataExpand, dataExpandAlt, dataExpandSquare, dataExpandSquareSolid, dataExternalLink, dataEye, dataEyeBright, dataEyeBrightSolid, dataEyeSlash, dataEyeSlashSolid, dataEyeSolid, dataEyeTracking, dataEyeTrackingSolid, dataEyedropper, dataFastForward, dataFastRewind, dataFeed, dataFeedSolid, dataFeedbackSolid, dataFile, dataFileAdd, dataFileAddSolid, dataFileEdit, dataFileEditSolid, dataFileError, dataFileErrorSolid, dataFileSolid, dataFilm, dataFilmSolid, dataFilter, dataFilterSolid, dataFireSolid, dataFitWidth, dataFlag, dataFlagSolid, dataFolder, dataFolderDownload, dataFolderDownloadSolid, dataFolderOpen, dataFolderOpenSolid, dataFolderSolid, dataFont, dataFontSize, dataFourDots, dataFourQuarterCircles, dataFourQuarterCirclesSolid, dataFrowningFace, dataFrowningFaceSolid, dataFullCircle, dataFullCircleSolid, dataFullscreen, dataFullscreenExit, dataGallery, dataGallerySolid, dataGamepad, dataGamepadSolid, dataGateway, dataGatewaySolid, dataGift, dataGiftSolid, dataGirl, dataGirlSolid, dataGradeCircle, dataGradeCircleSolid, dataHamburger, dataHammerSolid, dataHeadphones, dataHeadphonesSolid, dataHeart, dataHeartCancel, dataHeartCancelSolid, dataHeartHandshakeSolid, dataHeartSolid, dataHeteronymSquare, dataHexagonSolid, dataHierarchy, dataHierarchySolid, dataHighSquare, dataHighSquareSolid, dataHome, dataHomeAltSolid, dataHomeSolid, dataHospital, dataHospitalSolid, dataHourglass, dataHourglassSolid, dataHouse, dataHouseSolid, dataIdCard, dataIdCardBack, dataIdCardBackSolid, dataIdCardSolid, dataIdCircle, dataIdSquare, dataImage, dataImageAdd, dataImageDesktopSolid, dataImageSolid, dataImageStar, dataImageStarSolid, dataImageUpload, dataImport, dataIndent, dataInfoCircle, dataInfoCircleSolid, dataInfoflow, dataIntelligence, dataIntelligenceSolid, dataIntelligentPrompt, dataInvoice, dataInvoiceSolid, dataItalic, dataKeyCommand, dataKeyDelete, dataKeyShift, dataKeyboard, dataLandingPageSolid, dataLayer, dataLayerSolid, dataLayout, dataLayoutSolid, dataLetterSpacing, dataLightning, dataLightningSolid, dataLineChart, dataLineChartAlt, dataLineChartAltSolid, dataLineChartSolid, dataLineHeight, dataLink, dataLinkAlt, dataLinkAltSolid, dataListChecked, dataListOrdered, dataListUnordered, dataLoading, dataLocation, dataLocationCopy, dataLocationCopySolid, dataLocationPin, dataLocationPinSolid, dataLocationSolid, dataLock, dataLockSolid, dataLongVideo, dataLongVideoSolid, dataLowSquare, dataLowSquareSolid, dataMagicWand, dataMagicWandSolid, dataMagnet, dataMagnetSolid, dataMarket, dataMarketSolid, dataMediaAdd, dataMedicalKit, dataMedicalKitSolid, dataMediumSquare, dataMediumSquareSolid, dataMenu, dataMigrate, dataMigrateSolid, dataMiniAppBaidu, dataMiniAppBaiduSolid, dataMiniAppWechat, dataMinimize, dataMinus, dataMinusCircle, dataMinusCircleSolid, dataMobileApp, dataMobileAppSolid, dataMotionGraphics, dataMove, dataMovieSolid, dataMusic, dataMusicSolid, dataMute, dataMuteSolid, dataNeutralFace, dataNeutralFaceSolid, dataOneToOne, dataOneToOneSolid, dataOrder, dataOrderSolid, dataOutdent, dataOutstanding, dataOutstandingSolid, dataPackageUpload, dataPackageUploadSolid, dataPaintBucket, dataPaintBucketSolid, dataPaperClip, dataPaperPlane, dataPaperPlaneSend, dataPaperPlaneSendSolid, dataPaperPlaneSolid, dataPaste, dataPasteImageSolid, dataPasteSolid, dataPath, dataPathSolid, dataPause, dataPauseCircle, dataPauseCircleSolid, dataPenWrite, dataPenWriteSolid, dataPencil, dataPencilSolid, dataPhone, dataPhoneCall, dataPhoneCallSolid, dataPhoneEye, dataPhoneEyeSolid, dataPhoneSolid, dataPieChart, dataPieChartSolid, dataPinSlant, dataPinSolid, dataPlay, dataPlayCircle, dataPlayCircleSolid, dataPlus, dataPlusCircle, dataPlusCircleSolid, dataPlusSquare, dataPlusSquareSolid, dataPowerOff, dataPrinterSolid, dataPuzzlePiece, dataPuzzlePieceSolid, dataPvShield, dataPvShieldSolid, dataQACommentSolid, dataQrcode, dataQualityCircle, dataQualityCircleSolid, dataQuestionCircle, dataQuestionCircleSolid, dataQuestionComment, dataQuestionCommentSolid, dataRecommendSquare, dataRecommendSquareSolid, dataRecommendation, dataRedo, dataRedoSolid, dataReport, dataReportBookmark, dataReportBookmarkSolid, dataReportCheck, dataReportCheckSolid, dataReportSearch, dataReportSearchSolid, dataReportSettings, dataReportSettingsSolid, dataReportSolid, dataReportStamp, dataReportStampSolid, dataReportStar, dataReportStarSolid, dataReportTrendSettings, dataReportTrendSettingsSolid, dataReportUser, dataReportUserSolid, dataRoad, dataRocketSolid, dataRotateAnticlockwise, dataRotateAnticlockwiseSolid, dataRotateClockwise, dataRotateClockwiseSolid, dataSave, dataSaveSolid, dataScan, dataSearch, dataSearchDesktop, dataSearchDesktopSolid, dataSearchHistory, dataSearchHistorySolid, dataSearchSolid, dataSettings, dataSettingsSolid, dataShare, dataShareAlt, dataShareAltSolid, dataShieldCheck, dataShieldCheckSolid, dataShieldCnySolid, dataShieldEllipsisSolid, dataShieldTimesSolid, dataShieldUser, dataShieldUserSolid, dataShieldWave, dataShieldWaveSolid, dataShoppingBag, dataShoppingBagSolid, dataShoppingCart, dataShoppingCartSolid, dataShortVideo, dataShortVideoSolid, dataShrink, dataSignOut, dataSkipBackward, dataSkipForward, dataSlidersSquare, dataSlidersSquareSolid, dataSmiley, dataSmileyComment, dataSmileySolid, dataSmileyStar, dataSmileyStarSolid, dataSort, dataSortAlt, dataSortAsc, dataSortDesc, dataSoundWave, dataSparklesSolid, dataSplit, dataSquareRotation, dataSquareRotationSolid, dataStamp, dataStampSolid, dataStar, dataStarDash, dataStarDashSoild, dataStarDashSolid, dataStarHalf, dataStarSolid, dataStop, dataStopSolid, dataStrikethrough, dataSwitch, dataSync, dataSyncCircle, dataSyringe, dataSyringesSolid, dataTag, dataTagSolid, dataTeam, dataTeamSolid, dataTelephone, dataTelephoneSolid, dataTemplate, dataTemplateSolid, dataTextFlowerSquare, dataTextFlowerSquareSolid, dataTextSquare, dataTextSquareAltSolid, dataTextSquareSolid, dataThumbDown, dataThumbDownSolid, dataThumbUp, dataThumbUpSolid, dataTimes, dataTimesCircle, dataTimesCircleSolid, dataToolbox, dataToolboxSolid, dataToolsSolid, dataTrackCut, dataTrackFrameLast, dataTrash, dataTrashSolid, dataTravelEarthPlaneSolid, dataTreasureChest, dataTreasureChestSolid, dataTrendDesktop, dataTrendDesktopSolid, dataTrendMonitor, dataTrendMonitorSolid, dataTrendPages, dataTrendPagesSolid, dataTrendReport, dataTrendReportSolid, dataTrendStarSolid, dataTrimLeft, dataTrimRight, dataTrophy, dataTrophySolid, dataTruck, dataTruckSolid, dataTv, dataTvSolid, dataTwoHearts, dataTwoHeartsSolid, dataUnderline, dataUndo, dataUndoSolid, dataUnlink, dataUnlock, dataUnlockSolid, dataUpdateWave, dataUpgrade, dataUpgradeSolid, dataUpload, dataUploadDesktop, dataUploadDesktopSolid, dataUser, dataUserAuthorization, dataUserBookmark, dataUserBookmarkSolid, dataUserCard, dataUserCardSolid, dataUserCircle, dataUserCircleSolid, dataUserCombined, dataUserCombinedSolid, dataUserFilter, dataUserFilterSolid, dataUserIntersection, dataUserIntersectionSolid, dataUserLabel, dataUserLabelSolid, dataUserMobile, dataUserMobileSolid, dataUserSearch, dataUserSearchSolid, dataUserSettings, dataUserSettingsSolid, dataUserSolid, dataUserStar, dataUserSync, dataUserSyncSolid, dataUserTieba, dataVideo, dataVideoAdd, dataVideoCrop, dataVideoCropSolid, dataVideoFilm, dataVideoFilmSolid, dataVideoFrameFirst, dataVideoHistory, dataVideoHistorySolid, dataVideoSolid, dataVideoUpload, dataVolume, dataVolumeSolid, dataWhirlpool, dataWhirlpoolSolid, dataWoman, dataYaoSquare, dataYingxiaotong, dataYingxiaotongSolid, dataZoomIn, dataZoomInSolid, dataZoomOut, dataZoomOutSolid } from 'dls-icons-data';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};
function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

var dlsColorBrand3 = '#bfd7ff';
var dlsColorBrand6 = '#1a6eff';
var dlsColorGray3 = '#e2e6f0';
var dlsColorGray4 = '#d3d9e6';

var gradientIdActive = 'dls-icon-gradient-active';
var gradientIdInactive = 'dls-icon-gradient-inactive';
var primaryColorActive = dlsColorBrand6;
var secondaryColorActive = dlsColorBrand3;
var primaryColorInactive = dlsColorGray4;
var secondaryColorInactive = dlsColorGray3;
var activeGradient = "<radialGradient id=\"".concat(gradientIdActive, "\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"matrix(23.2 32.9 -24.293 17.13 .8 -4.8)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"").concat(secondaryColorActive, "\"/><stop offset=\"1\" stop-color=\"").concat(primaryColorActive, "\"/></radialGradient>");
var inactiveGradient = "<radialGradient id=\"".concat(gradientIdInactive, "\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"rotate(59 5.785 .462) scale(29 23.634)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"").concat(secondaryColorInactive, "\"/><stop offset=\"1\" stop-color=\"").concat(primaryColorInactive, "\"/></radialGradient>");
var markup = "<defs>".concat(activeGradient).concat(inactiveGradient, "</defs>");
var attributes = {
  viewBox: '0 0 24 24'
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".dls-icon{display:inline-block;height:1em;vertical-align:-.125em;width:auto}.dls-icon-shared{height:0;position:absolute;visibility:hidden;width:0}.dls-icon:not([fill]){fill:currentColor}.dls-icon-spin{animation:dls-icon-spin var(--dls-icon-spin-duration,1s) infinite linear}.dls-icon-active [fill=currentColor],.dls-icon-active [fill=currentColor] :not([fill=none]),.dls-icon-active path:not([fill=none],[fill=none] path){fill:url(#dls-icon-gradient-active) #1a6eff}.dls-icon-active [stroke=currentColor]{stroke:url(#dls-icon-gradient-active) #1a6eff}.dls-icon-inactive [fill=currentColor],.dls-icon-inactive [fill=currentColor] :not([fill=none]),.dls-icon-inactive path:not([fill=none],[fill=none] path){fill:url(#dls-icon-gradient-inactive) #d3d9e6}.dls-icon-inactive [stroke=currentColor]{stroke:url(#dls-icon-gradient-inactive) #d3d9e6}@keyframes dls-icon-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
styleInject(css_248z);

var _excluded = ["title"],
    _excluded2 = ["staticClass", "class", "attrs"],
    _excluded3 = ["staticClass", "class", "attrs"];
var baseClassName = 'dls-icon';
function createIcon(_ref) {
  var name = _ref.name,
      content = _ref.content,
      width = _ref.width,
      height = _ref.height,
      attributes = _ref.attributes;
  return {
    functional: true,
    name: name,
    props: {
      spin: Boolean,
      active: {
        type: Boolean,
        "default": undefined
      }
    },
    render: function render(h, _ref2) {
      var _ref2$props = _ref2.props;
      _ref2$props = _ref2$props === void 0 ? {} : _ref2$props;
      var spin = _ref2$props.spin,
          active = _ref2$props.active,
          _ref2$data = _ref2.data,
          data = _ref2$data === void 0 ? {} : _ref2$data;
      var staticClass = data.staticClass,
          dynamicClass = data["class"],
          _data$attrs = data.attrs;
      _data$attrs = _data$attrs === void 0 ? {} : _data$attrs;

      var title = _data$attrs.title,
          attrs = _objectWithoutProperties(_data$attrs, _excluded),
          rest = _objectWithoutProperties(data, _excluded2);

      var tabindex = attrs.tabindex;
      var iconClasses = [baseClassName, staticClass, dynamicClass];

      if (spin) {
        iconClasses.push("".concat(baseClassName, "-spin"));
      }

      if (typeof active !== 'undefined') {
        iconClasses.push("".concat(baseClassName, "-").concat(active ? 'active' : 'inactive'));
      }

      return h('svg', _objectSpread2({
        "class": iconClasses,
        attrs: _objectSpread2(_objectSpread2({}, attributes), {}, {
          width: width,
          height: height,
          focusable: tabindex !== '0' ? 'false' : null
        }, attrs),
        domProps: {
          innerHTML: (title ? "<title>".concat(escapeHTML(title), "</title>") : '') + content
        }
      }, rest));
    }
  };
}
var SharedResources = {
  functional: true,
  name: 'SharedResources',
  render: function render(h, _ref3) {
    var _ref3$data = _ref3.data,
        data = _ref3$data === void 0 ? {} : _ref3$data;

    var staticClass = data.staticClass,
        dynamicClass = data["class"],
        attrs = data.attrs,
        rest = _objectWithoutProperties(data, _excluded3);

    var iconClasses = [baseClassName, "".concat(baseClassName, "-shared"), staticClass, dynamicClass];
    return h('svg', _objectSpread2({
      "class": iconClasses,
      attrs: _objectSpread2(_objectSpread2(_objectSpread2({}, attributes), attrs), {}, {
        focusable: 'false'
      }),
      domProps: {
        innerHTML: markup
      }
    }, rest));
  }
};

var IconQACommentSolid = /*#__PURE__*/createIcon(dataQACommentSolid);
var IconQACommentSolid$1 = IconQACommentSolid;

var IconAbTest = /*#__PURE__*/createIcon(dataAbTest);
var IconAbTest$1 = IconAbTest;

var IconAbTestSolid = /*#__PURE__*/createIcon(dataAbTestSolid);
var IconAbTestSolid$1 = IconAbTestSolid;

var IconAbstract = /*#__PURE__*/createIcon(dataAbstract);
var IconAbstract$1 = IconAbstract;

var IconAbstractSolid = /*#__PURE__*/createIcon(dataAbstractSolid);
var IconAbstractSolid$1 = IconAbstractSolid;

var IconAcademicCap = /*#__PURE__*/createIcon(dataAcademicCap);
var IconAcademicCap$1 = IconAcademicCap;

var IconAcademicCapSolid = /*#__PURE__*/createIcon(dataAcademicCapSolid);
var IconAcademicCapSolid$1 = IconAcademicCapSolid;

var IconAdDeliveryCircleSolid = /*#__PURE__*/createIcon(dataAdDeliveryCircleSolid);
var IconAdDeliveryCircleSolid$1 = IconAdDeliveryCircleSolid;

var IconAddPauseSquare = /*#__PURE__*/createIcon(dataAddPauseSquare);
var IconAddPauseSquare$1 = IconAddPauseSquare;

var IconAdjust = /*#__PURE__*/createIcon(dataAdjust);
var IconAdjust$1 = IconAdjust;

var IconAfterSquare = /*#__PURE__*/createIcon(dataAfterSquare);
var IconAfterSquare$1 = IconAfterSquare;

var IconAfterSquareSolid = /*#__PURE__*/createIcon(dataAfterSquareSolid);
var IconAfterSquareSolid$1 = IconAfterSquareSolid;

var IconAi = /*#__PURE__*/createIcon(dataAi);
var IconAi$1 = IconAi;

var IconAiBubble = /*#__PURE__*/createIcon(dataAiBubble);
var IconAiBubble$1 = IconAiBubble;

var IconAiBubbleSolid = /*#__PURE__*/createIcon(dataAiBubbleSolid);
var IconAiBubbleSolid$1 = IconAiBubbleSolid;

var IconAlignBottom = /*#__PURE__*/createIcon(dataAlignBottom);
var IconAlignBottom$1 = IconAlignBottom;

var IconAlignCenter = /*#__PURE__*/createIcon(dataAlignCenter);
var IconAlignCenter$1 = IconAlignCenter;

var IconAlignLeft = /*#__PURE__*/createIcon(dataAlignLeft);
var IconAlignLeft$1 = IconAlignLeft;

var IconAlignRight = /*#__PURE__*/createIcon(dataAlignRight);
var IconAlignRight$1 = IconAlignRight;

var IconAlignTop = /*#__PURE__*/createIcon(dataAlignTop);
var IconAlignTop$1 = IconAlignTop;

var IconAndroid = /*#__PURE__*/createIcon(dataAndroid);
var IconAndroid$1 = IconAndroid;

var IconAnticlockwise = /*#__PURE__*/createIcon(dataAnticlockwise);
var IconAnticlockwise$1 = IconAnticlockwise;

var IconAppStore = /*#__PURE__*/createIcon(dataAppStore);
var IconAppStore$1 = IconAppStore;

var IconApps = /*#__PURE__*/createIcon(dataApps);
var IconApps$1 = IconApps;

var IconAppsSettings = /*#__PURE__*/createIcon(dataAppsSettings);
var IconAppsSettings$1 = IconAppsSettings;

var IconAppsSettingsSolid = /*#__PURE__*/createIcon(dataAppsSettingsSolid);
var IconAppsSettingsSolid$1 = IconAppsSettingsSolid;

var IconAppsSolid = /*#__PURE__*/createIcon(dataAppsSolid);
var IconAppsSolid$1 = IconAppsSolid;

var IconArrowCurveDownRightSolid = /*#__PURE__*/createIcon(dataArrowCurveDownRightSolid);
var IconArrowCurveDownRightSolid$1 = IconArrowCurveDownRightSolid;

var IconArrowCurveUpRightSolid = /*#__PURE__*/createIcon(dataArrowCurveUpRightSolid);
var IconArrowCurveUpRightSolid$1 = IconArrowCurveUpRightSolid;

var IconArrowDown = /*#__PURE__*/createIcon(dataArrowDown);
var IconArrowDown$1 = IconArrowDown;

var IconArrowDownLeft = /*#__PURE__*/createIcon(dataArrowDownLeft);
var IconArrowDownLeft$1 = IconArrowDownLeft;

var IconArrowDownRight = /*#__PURE__*/createIcon(dataArrowDownRight);
var IconArrowDownRight$1 = IconArrowDownRight;

var IconArrowDownSolid = /*#__PURE__*/createIcon(dataArrowDownSolid);
var IconArrowDownSolid$1 = IconArrowDownSolid;

var IconArrowLeft = /*#__PURE__*/createIcon(dataArrowLeft);
var IconArrowLeft$1 = IconArrowLeft;

var IconArrowLeftSolid = /*#__PURE__*/createIcon(dataArrowLeftSolid);
var IconArrowLeftSolid$1 = IconArrowLeftSolid;

var IconArrowRight = /*#__PURE__*/createIcon(dataArrowRight);
var IconArrowRight$1 = IconArrowRight;

var IconArrowRightSolid = /*#__PURE__*/createIcon(dataArrowRightSolid);
var IconArrowRightSolid$1 = IconArrowRightSolid;

var IconArrowToBottom = /*#__PURE__*/createIcon(dataArrowToBottom);
var IconArrowToBottom$1 = IconArrowToBottom;

var IconArrowToTop = /*#__PURE__*/createIcon(dataArrowToTop);
var IconArrowToTop$1 = IconArrowToTop;

var IconArrowToTopSoild = /*#__PURE__*/createIcon(dataArrowToTopSoild);
/** @deprecated */

var IconArrowToTopSoild$1 = IconArrowToTopSoild;

var IconArrowToTopSolid = /*#__PURE__*/createIcon(dataArrowToTopSolid);
var IconArrowToTopSolid$1 = IconArrowToTopSolid;

var IconArrowUUpLeft = /*#__PURE__*/createIcon(dataArrowUUpLeft);
var IconArrowUUpLeft$1 = IconArrowUUpLeft;

var IconArrowUUpRight = /*#__PURE__*/createIcon(dataArrowUUpRight);
var IconArrowUUpRight$1 = IconArrowUUpRight;

var IconArrowUp = /*#__PURE__*/createIcon(dataArrowUp);
var IconArrowUp$1 = IconArrowUp;

var IconArrowUpSolid = /*#__PURE__*/createIcon(dataArrowUpSolid);
var IconArrowUpSolid$1 = IconArrowUpSolid;

var IconAsterisk = /*#__PURE__*/createIcon(dataAsterisk);
var IconAsterisk$1 = IconAsterisk;

var IconAttribute = /*#__PURE__*/createIcon(dataAttribute);
var IconAttribute$1 = IconAttribute;

var IconAttributeSolid = /*#__PURE__*/createIcon(dataAttributeSolid);
var IconAttributeSolid$1 = IconAttributeSolid;

var IconAudio = /*#__PURE__*/createIcon(dataAudio);
var IconAudio$1 = IconAudio;

var IconAudioSolid = /*#__PURE__*/createIcon(dataAudioSolid);
var IconAudioSolid$1 = IconAudioSolid;

var IconBabyBottle = /*#__PURE__*/createIcon(dataBabyBottle);
var IconBabyBottle$1 = IconBabyBottle;

var IconBabyBottleSolid = /*#__PURE__*/createIcon(dataBabyBottleSolid);
var IconBabyBottleSolid$1 = IconBabyBottleSolid;

var IconBackground = /*#__PURE__*/createIcon(dataBackground);
var IconBackground$1 = IconBackground;

var IconBackgroundSolid = /*#__PURE__*/createIcon(dataBackgroundSolid);
var IconBackgroundSolid$1 = IconBackgroundSolid;

var IconBackgroundSwitchSolid = /*#__PURE__*/createIcon(dataBackgroundSwitchSolid);
var IconBackgroundSwitchSolid$1 = IconBackgroundSwitchSolid;

var IconBarChart = /*#__PURE__*/createIcon(dataBarChart);
var IconBarChart$1 = IconBarChart;

var IconBarChartAlt = /*#__PURE__*/createIcon(dataBarChartAlt);
var IconBarChartAlt$1 = IconBarChartAlt;

var IconBarChartAltSolid = /*#__PURE__*/createIcon(dataBarChartAltSolid);
var IconBarChartAltSolid$1 = IconBarChartAltSolid;

var IconBarChartSolid = /*#__PURE__*/createIcon(dataBarChartSolid);
var IconBarChartSolid$1 = IconBarChartSolid;

var IconBarChartSquare = /*#__PURE__*/createIcon(dataBarChartSquare);
var IconBarChartSquare$1 = IconBarChartSquare;

var IconBarChartSquareSolid = /*#__PURE__*/createIcon(dataBarChartSquareSolid);
var IconBarChartSquareSolid$1 = IconBarChartSquareSolid;

var IconBeforeSquare = /*#__PURE__*/createIcon(dataBeforeSquare);
var IconBeforeSquare$1 = IconBeforeSquare;

var IconBeforeSquareSolid = /*#__PURE__*/createIcon(dataBeforeSquareSolid);
var IconBeforeSquareSolid$1 = IconBeforeSquareSolid;

var IconBell = /*#__PURE__*/createIcon(dataBell);
var IconBell$1 = IconBell;

var IconBellSolid = /*#__PURE__*/createIcon(dataBellSolid);
var IconBellSolid$1 = IconBellSolid;

var IconBold = /*#__PURE__*/createIcon(dataBold);
var IconBold$1 = IconBold;

var IconBook = /*#__PURE__*/createIcon(dataBook);
var IconBook$1 = IconBook;

var IconBookBookmark = /*#__PURE__*/createIcon(dataBookBookmark);
var IconBookBookmark$1 = IconBookBookmark;

var IconBookBookmarkCheckSolid = /*#__PURE__*/createIcon(dataBookBookmarkCheckSolid);
var IconBookBookmarkCheckSolid$1 = IconBookBookmarkCheckSolid;

var IconBookBookmarkSolid = /*#__PURE__*/createIcon(dataBookBookmarkSolid);
var IconBookBookmarkSolid$1 = IconBookBookmarkSolid;

var IconBookOpen = /*#__PURE__*/createIcon(dataBookOpen);
var IconBookOpen$1 = IconBookOpen;

var IconBookSolid = /*#__PURE__*/createIcon(dataBookSolid);
var IconBookSolid$1 = IconBookSolid;

var IconBookmark = /*#__PURE__*/createIcon(dataBookmark);
var IconBookmark$1 = IconBookmark;

var IconBookmarkSolid = /*#__PURE__*/createIcon(dataBookmarkSolid);
var IconBookmarkSolid$1 = IconBookmarkSolid;

var IconBooksBookmark = /*#__PURE__*/createIcon(dataBooksBookmark);
var IconBooksBookmark$1 = IconBooksBookmark;

var IconBooksBookmarkSolid = /*#__PURE__*/createIcon(dataBooksBookmarkSolid);
var IconBooksBookmarkSolid$1 = IconBooksBookmarkSolid;

var IconBox = /*#__PURE__*/createIcon(dataBox);
var IconBox$1 = IconBox;

var IconBoxSolid = /*#__PURE__*/createIcon(dataBoxSolid);
var IconBoxSolid$1 = IconBoxSolid;

var IconBrush = /*#__PURE__*/createIcon(dataBrush);
var IconBrush$1 = IconBrush;

var IconBuilding = /*#__PURE__*/createIcon(dataBuilding);
var IconBuilding$1 = IconBuilding;

var IconBuildingSolid = /*#__PURE__*/createIcon(dataBuildingSolid);
var IconBuildingSolid$1 = IconBuildingSolid;

var IconBulb = /*#__PURE__*/createIcon(dataBulb);
var IconBulb$1 = IconBulb;

var IconBulbDash = /*#__PURE__*/createIcon(dataBulbDash);
var IconBulbDash$1 = IconBulbDash;

var IconBulbDashSolid = /*#__PURE__*/createIcon(dataBulbDashSolid);
var IconBulbDashSolid$1 = IconBulbDashSolid;

var IconBulbSolid = /*#__PURE__*/createIcon(dataBulbSolid);
var IconBulbSolid$1 = IconBulbSolid;

var IconBulbTrendSolid = /*#__PURE__*/createIcon(dataBulbTrendSolid);
var IconBulbTrendSolid$1 = IconBulbTrendSolid;

var IconBullseye = /*#__PURE__*/createIcon(dataBullseye);
var IconBullseye$1 = IconBullseye;

var IconBullseyeHit = /*#__PURE__*/createIcon(dataBullseyeHit);
var IconBullseyeHit$1 = IconBullseyeHit;

var IconBullseyeHitSolid = /*#__PURE__*/createIcon(dataBullseyeHitSolid);
var IconBullseyeHitSolid$1 = IconBullseyeHitSolid;

var IconCalendar = /*#__PURE__*/createIcon(dataCalendar);
var IconCalendar$1 = IconCalendar;

var IconCalendarCny = /*#__PURE__*/createIcon(dataCalendarCny);
var IconCalendarCny$1 = IconCalendarCny;

var IconCalendarCnySolid = /*#__PURE__*/createIcon(dataCalendarCnySolid);
var IconCalendarCnySolid$1 = IconCalendarCnySolid;

var IconCalendarHeart = /*#__PURE__*/createIcon(dataCalendarHeart);
var IconCalendarHeart$1 = IconCalendarHeart;

var IconCalendarHeartSolid = /*#__PURE__*/createIcon(dataCalendarHeartSolid);
var IconCalendarHeartSolid$1 = IconCalendarHeartSolid;

var IconCalendarSolid = /*#__PURE__*/createIcon(dataCalendarSolid);
var IconCalendarSolid$1 = IconCalendarSolid;

var IconCamera = /*#__PURE__*/createIcon(dataCamera);
var IconCamera$1 = IconCamera;

var IconCameraAdd = /*#__PURE__*/createIcon(dataCameraAdd);
var IconCameraAdd$1 = IconCameraAdd;

var IconCameraAddSolid = /*#__PURE__*/createIcon(dataCameraAddSolid);
var IconCameraAddSolid$1 = IconCameraAddSolid;

var IconCameraSolid = /*#__PURE__*/createIcon(dataCameraSolid);
var IconCameraSolid$1 = IconCameraSolid;

var IconCar = /*#__PURE__*/createIcon(dataCar);
var IconCar$1 = IconCar;

var IconCarSolid = /*#__PURE__*/createIcon(dataCarSolid);
var IconCarSolid$1 = IconCarSolid;

var IconCardSolid = /*#__PURE__*/createIcon(dataCardSolid);
var IconCardSolid$1 = IconCardSolid;

var IconCaretDown = /*#__PURE__*/createIcon(dataCaretDown);
var IconCaretDown$1 = IconCaretDown;

var IconCaretLeft = /*#__PURE__*/createIcon(dataCaretLeft);
var IconCaretLeft$1 = IconCaretLeft;

var IconCaretRight = /*#__PURE__*/createIcon(dataCaretRight);
var IconCaretRight$1 = IconCaretRight;

var IconCaretUp = /*#__PURE__*/createIcon(dataCaretUp);
var IconCaretUp$1 = IconCaretUp;

var IconCaretsOpposite = /*#__PURE__*/createIcon(dataCaretsOpposite);
var IconCaretsOpposite$1 = IconCaretsOpposite;

var IconCellphone = /*#__PURE__*/createIcon(dataCellphone);
var IconCellphone$1 = IconCellphone;

var IconCellphoneSolid = /*#__PURE__*/createIcon(dataCellphoneSolid);
var IconCellphoneSolid$1 = IconCellphoneSolid;

var IconChat = /*#__PURE__*/createIcon(dataChat);
var IconChat$1 = IconChat;

var IconChatSolid = /*#__PURE__*/createIcon(dataChatSolid);
var IconChatSolid$1 = IconChatSolid;

var IconCheck = /*#__PURE__*/createIcon(dataCheck);
var IconCheck$1 = IconCheck;

var IconCheckCircle = /*#__PURE__*/createIcon(dataCheckCircle);
var IconCheckCircle$1 = IconCheckCircle;

var IconCheckCircleSolid = /*#__PURE__*/createIcon(dataCheckCircleSolid);
var IconCheckCircleSolid$1 = IconCheckCircleSolid;

var IconCheckDesktop = /*#__PURE__*/createIcon(dataCheckDesktop);
var IconCheckDesktop$1 = IconCheckDesktop;

var IconCheckDesktopSolid = /*#__PURE__*/createIcon(dataCheckDesktopSolid);
var IconCheckDesktopSolid$1 = IconCheckDesktopSolid;

var IconCheckSquare = /*#__PURE__*/createIcon(dataCheckSquare);
var IconCheckSquare$1 = IconCheckSquare;

var IconCheckSquareSolid = /*#__PURE__*/createIcon(dataCheckSquareSolid);
var IconCheckSquareSolid$1 = IconCheckSquareSolid;

var IconChevronDoubleDown = /*#__PURE__*/createIcon(dataChevronDoubleDown);
var IconChevronDoubleDown$1 = IconChevronDoubleDown;

var IconChevronDoubleLeft = /*#__PURE__*/createIcon(dataChevronDoubleLeft);
var IconChevronDoubleLeft$1 = IconChevronDoubleLeft;

var IconChevronDoubleRight = /*#__PURE__*/createIcon(dataChevronDoubleRight);
var IconChevronDoubleRight$1 = IconChevronDoubleRight;

var IconChevronDoubleUp = /*#__PURE__*/createIcon(dataChevronDoubleUp);
var IconChevronDoubleUp$1 = IconChevronDoubleUp;

var IconChevronDown = /*#__PURE__*/createIcon(dataChevronDown);
var IconChevronDown$1 = IconChevronDown;

var IconChevronLeft = /*#__PURE__*/createIcon(dataChevronLeft);
var IconChevronLeft$1 = IconChevronLeft;

var IconChevronLeftCircle = /*#__PURE__*/createIcon(dataChevronLeftCircle);
var IconChevronLeftCircle$1 = IconChevronLeftCircle;

var IconChevronLeftCircleSolid = /*#__PURE__*/createIcon(dataChevronLeftCircleSolid);
var IconChevronLeftCircleSolid$1 = IconChevronLeftCircleSolid;

var IconChevronRight = /*#__PURE__*/createIcon(dataChevronRight);
var IconChevronRight$1 = IconChevronRight;

var IconChevronRightCircle = /*#__PURE__*/createIcon(dataChevronRightCircle);
var IconChevronRightCircle$1 = IconChevronRightCircle;

var IconChevronRightCircleSolid = /*#__PURE__*/createIcon(dataChevronRightCircleSolid);
var IconChevronRightCircleSolid$1 = IconChevronRightCircleSolid;

var IconChevronUp = /*#__PURE__*/createIcon(dataChevronUp);
var IconChevronUp$1 = IconChevronUp;

var IconCircleExtend = /*#__PURE__*/createIcon(dataCircleExtend);
var IconCircleExtend$1 = IconCircleExtend;

var IconCircleExtendSolid = /*#__PURE__*/createIcon(dataCircleExtendSolid);
var IconCircleExtendSolid$1 = IconCircleExtendSolid;

var IconCircleRotation = /*#__PURE__*/createIcon(dataCircleRotation);
var IconCircleRotation$1 = IconCircleRotation;

var IconCircleRotationSolid = /*#__PURE__*/createIcon(dataCircleRotationSolid);
var IconCircleRotationSolid$1 = IconCircleRotationSolid;

var IconClock = /*#__PURE__*/createIcon(dataClock);
var IconClock$1 = IconClock;

var IconClockSolid = /*#__PURE__*/createIcon(dataClockSolid);
var IconClockSolid$1 = IconClockSolid;

var IconClockwise = /*#__PURE__*/createIcon(dataClockwise);
var IconClockwise$1 = IconClockwise;

var IconCloudUploadSolid = /*#__PURE__*/createIcon(dataCloudUploadSolid);
var IconCloudUploadSolid$1 = IconCloudUploadSolid;

var IconCnyCircle = /*#__PURE__*/createIcon(dataCnyCircle);
var IconCnyCircle$1 = IconCnyCircle;

var IconCnyCircleSolid = /*#__PURE__*/createIcon(dataCnyCircleSolid);
var IconCnyCircleSolid$1 = IconCnyCircleSolid;

var IconCnyRefund = /*#__PURE__*/createIcon(dataCnyRefund);
var IconCnyRefund$1 = IconCnyRefund;

var IconCnyWallet = /*#__PURE__*/createIcon(dataCnyWallet);
var IconCnyWallet$1 = IconCnyWallet;

var IconCnyWalletSolid = /*#__PURE__*/createIcon(dataCnyWalletSolid);
var IconCnyWalletSolid$1 = IconCnyWalletSolid;

var IconCoin = /*#__PURE__*/createIcon(dataCoin);
var IconCoin$1 = IconCoin;

var IconCoinDiamond = /*#__PURE__*/createIcon(dataCoinDiamond);
var IconCoinDiamond$1 = IconCoinDiamond;

var IconCoinDiamondSolid = /*#__PURE__*/createIcon(dataCoinDiamondSolid);
var IconCoinDiamondSolid$1 = IconCoinDiamondSolid;

var IconCoinSolid = /*#__PURE__*/createIcon(dataCoinSolid);
var IconCoinSolid$1 = IconCoinSolid;

var IconColorPalette = /*#__PURE__*/createIcon(dataColorPalette);
var IconColorPalette$1 = IconColorPalette;

var IconColorPaletteSolid = /*#__PURE__*/createIcon(dataColorPaletteSolid);
var IconColorPaletteSolid$1 = IconColorPaletteSolid;

var IconCompass = /*#__PURE__*/createIcon(dataCompass);
var IconCompass$1 = IconCompass;

var IconCompassSolid = /*#__PURE__*/createIcon(dataCompassSolid);
var IconCompassSolid$1 = IconCompassSolid;

var IconComponent = /*#__PURE__*/createIcon(dataComponent);
var IconComponent$1 = IconComponent;

var IconComponentSolid = /*#__PURE__*/createIcon(dataComponentSolid);
var IconComponentSolid$1 = IconComponentSolid;

var IconCopy = /*#__PURE__*/createIcon(dataCopy);
var IconCopy$1 = IconCopy;

var IconCopySolid = /*#__PURE__*/createIcon(dataCopySolid);
var IconCopySolid$1 = IconCopySolid;

var IconCouponMinus = /*#__PURE__*/createIcon(dataCouponMinus);
var IconCouponMinus$1 = IconCouponMinus;

var IconCouponMinusSolid = /*#__PURE__*/createIcon(dataCouponMinusSolid);
var IconCouponMinusSolid$1 = IconCouponMinusSolid;

var IconCouponPercent = /*#__PURE__*/createIcon(dataCouponPercent);
var IconCouponPercent$1 = IconCouponPercent;

var IconCouponPercentSolid = /*#__PURE__*/createIcon(dataCouponPercentSolid);
var IconCouponPercentSolid$1 = IconCouponPercentSolid;

var IconCrop = /*#__PURE__*/createIcon(dataCrop);
var IconCrop$1 = IconCrop;

var IconCropSolid = /*#__PURE__*/createIcon(dataCropSolid);
var IconCropSolid$1 = IconCropSolid;

var IconCrown = /*#__PURE__*/createIcon(dataCrown);
var IconCrown$1 = IconCrown;

var IconCrownSolid = /*#__PURE__*/createIcon(dataCrownSolid);
var IconCrownSolid$1 = IconCrownSolid;

var IconCube = /*#__PURE__*/createIcon(dataCube);
var IconCube$1 = IconCube;

var IconCubeEye = /*#__PURE__*/createIcon(dataCubeEye);
var IconCubeEye$1 = IconCubeEye;

var IconCubeEyeSolid = /*#__PURE__*/createIcon(dataCubeEyeSolid);
var IconCubeEyeSolid$1 = IconCubeEyeSolid;

var IconCubeSolid = /*#__PURE__*/createIcon(dataCubeSolid);
var IconCubeSolid$1 = IconCubeSolid;

var IconCurveSquare = /*#__PURE__*/createIcon(dataCurveSquare);
var IconCurveSquare$1 = IconCurveSquare;

var IconCurveSquareSolid = /*#__PURE__*/createIcon(dataCurveSquareSolid);
var IconCurveSquareSolid$1 = IconCurveSquareSolid;

var IconCustomer = /*#__PURE__*/createIcon(dataCustomer);
var IconCustomer$1 = IconCustomer;

var IconCustomerService = /*#__PURE__*/createIcon(dataCustomerService);
var IconCustomerService$1 = IconCustomerService;

var IconCustomerSettings = /*#__PURE__*/createIcon(dataCustomerSettings);
var IconCustomerSettings$1 = IconCustomerSettings;

var IconCustomerSettingsSolid = /*#__PURE__*/createIcon(dataCustomerSettingsSolid);
var IconCustomerSettingsSolid$1 = IconCustomerSettingsSolid;

var IconCustomerSolid = /*#__PURE__*/createIcon(dataCustomerSolid);
var IconCustomerSolid$1 = IconCustomerSolid;

var IconCut = /*#__PURE__*/createIcon(dataCut);
var IconCut$1 = IconCut;

var IconCutSolid = /*#__PURE__*/createIcon(dataCutSolid);
var IconCutSolid$1 = IconCutSolid;

var IconData = /*#__PURE__*/createIcon(dataData);
var IconData$1 = IconData;

var IconDataMarket = /*#__PURE__*/createIcon(dataDataMarket);
var IconDataMarket$1 = IconDataMarket;

var IconDataMarketSolid = /*#__PURE__*/createIcon(dataDataMarketSolid);
var IconDataMarketSolid$1 = IconDataMarketSolid;

var IconDataSolid = /*#__PURE__*/createIcon(dataDataSolid);
var IconDataSolid$1 = IconDataSolid;

var IconDatabase = /*#__PURE__*/createIcon(dataDatabase);
var IconDatabase$1 = IconDatabase;

var IconDatabaseSolid = /*#__PURE__*/createIcon(dataDatabaseSolid);
var IconDatabaseSolid$1 = IconDatabaseSolid;

var IconDecreaseWidth = /*#__PURE__*/createIcon(dataDecreaseWidth);
var IconDecreaseWidth$1 = IconDecreaseWidth;

var IconDesktop = /*#__PURE__*/createIcon(dataDesktop);
var IconDesktop$1 = IconDesktop;

var IconDesktopSolid = /*#__PURE__*/createIcon(dataDesktopSolid);
var IconDesktopSolid$1 = IconDesktopSolid;

var IconDetailList = /*#__PURE__*/createIcon(dataDetailList);
var IconDetailList$1 = IconDetailList;

var IconDetailListSolid = /*#__PURE__*/createIcon(dataDetailListSolid);
var IconDetailListSolid$1 = IconDetailListSolid;

var IconDiamond = /*#__PURE__*/createIcon(dataDiamond);
var IconDiamond$1 = IconDiamond;

var IconDiamondSolid = /*#__PURE__*/createIcon(dataDiamondSolid);
var IconDiamondSolid$1 = IconDiamondSolid;

var IconDollarCircle = /*#__PURE__*/createIcon(dataDollarCircle);
var IconDollarCircle$1 = IconDollarCircle;

var IconDollarCircleSolid = /*#__PURE__*/createIcon(dataDollarCircleSolid);
var IconDollarCircleSolid$1 = IconDollarCircleSolid;

var IconDoubleCircle = /*#__PURE__*/createIcon(dataDoubleCircle);
var IconDoubleCircle$1 = IconDoubleCircle;

var IconDoubleCircleSolid = /*#__PURE__*/createIcon(dataDoubleCircleSolid);
var IconDoubleCircleSolid$1 = IconDoubleCircleSolid;

var IconDownload = /*#__PURE__*/createIcon(dataDownload);
var IconDownload$1 = IconDownload;

var IconDragIndicator = /*#__PURE__*/createIcon(dataDragIndicator);
var IconDragIndicator$1 = IconDragIndicator;

var IconEdit = /*#__PURE__*/createIcon(dataEdit);
var IconEdit$1 = IconEdit;

var IconEditSolid = /*#__PURE__*/createIcon(dataEditSolid);
var IconEditSolid$1 = IconEditSolid;

var IconElement = /*#__PURE__*/createIcon(dataElement);
var IconElement$1 = IconElement;

var IconElementSolid = /*#__PURE__*/createIcon(dataElementSolid);
var IconElementSolid$1 = IconElementSolid;

var IconEllipsis = /*#__PURE__*/createIcon(dataEllipsis);
var IconEllipsis$1 = IconEllipsis;

var IconEllipsisCircle = /*#__PURE__*/createIcon(dataEllipsisCircle);
var IconEllipsisCircle$1 = IconEllipsisCircle;

var IconEllipsisCircleSolid = /*#__PURE__*/createIcon(dataEllipsisCircleSolid);
var IconEllipsisCircleSolid$1 = IconEllipsisCircleSolid;

var IconEllipsisVertical = /*#__PURE__*/createIcon(dataEllipsisVertical);
var IconEllipsisVertical$1 = IconEllipsisVertical;

var IconEnglishComment = /*#__PURE__*/createIcon(dataEnglishComment);
var IconEnglishComment$1 = IconEnglishComment;

var IconEnglishCommentSolid = /*#__PURE__*/createIcon(dataEnglishCommentSolid);
var IconEnglishCommentSolid$1 = IconEnglishCommentSolid;

var IconEnvelope = /*#__PURE__*/createIcon(dataEnvelope);
var IconEnvelope$1 = IconEnvelope;

var IconEnvelopeOpen = /*#__PURE__*/createIcon(dataEnvelopeOpen);
var IconEnvelopeOpen$1 = IconEnvelopeOpen;

var IconEnvelopeOpenSolid = /*#__PURE__*/createIcon(dataEnvelopeOpenSolid);
var IconEnvelopeOpenSolid$1 = IconEnvelopeOpenSolid;

var IconEnvelopeSolid = /*#__PURE__*/createIcon(dataEnvelopeSolid);
var IconEnvelopeSolid$1 = IconEnvelopeSolid;

var IconExcellentBookmark = /*#__PURE__*/createIcon(dataExcellentBookmark);
var IconExcellentBookmark$1 = IconExcellentBookmark;

var IconExcellentBookmarkSolid = /*#__PURE__*/createIcon(dataExcellentBookmarkSolid);
var IconExcellentBookmarkSolid$1 = IconExcellentBookmarkSolid;

var IconExclamationCircle = /*#__PURE__*/createIcon(dataExclamationCircle);
var IconExclamationCircle$1 = IconExclamationCircle;

var IconExclamationCircleSolid = /*#__PURE__*/createIcon(dataExclamationCircleSolid);
var IconExclamationCircleSolid$1 = IconExclamationCircleSolid;

var IconExclamationTriangle = /*#__PURE__*/createIcon(dataExclamationTriangle);
var IconExclamationTriangle$1 = IconExclamationTriangle;

var IconExclamationTriangleSolid = /*#__PURE__*/createIcon(dataExclamationTriangleSolid);
var IconExclamationTriangleSolid$1 = IconExclamationTriangleSolid;

var IconExpand = /*#__PURE__*/createIcon(dataExpand);
var IconExpand$1 = IconExpand;

var IconExpandAlt = /*#__PURE__*/createIcon(dataExpandAlt);
var IconExpandAlt$1 = IconExpandAlt;

var IconExpandSquare = /*#__PURE__*/createIcon(dataExpandSquare);
var IconExpandSquare$1 = IconExpandSquare;

var IconExpandSquareSolid = /*#__PURE__*/createIcon(dataExpandSquareSolid);
var IconExpandSquareSolid$1 = IconExpandSquareSolid;

var IconExternalLink = /*#__PURE__*/createIcon(dataExternalLink);
var IconExternalLink$1 = IconExternalLink;

var IconEye = /*#__PURE__*/createIcon(dataEye);
var IconEye$1 = IconEye;

var IconEyeBright = /*#__PURE__*/createIcon(dataEyeBright);
var IconEyeBright$1 = IconEyeBright;

var IconEyeBrightSolid = /*#__PURE__*/createIcon(dataEyeBrightSolid);
var IconEyeBrightSolid$1 = IconEyeBrightSolid;

var IconEyeSlash = /*#__PURE__*/createIcon(dataEyeSlash);
var IconEyeSlash$1 = IconEyeSlash;

var IconEyeSlashSolid = /*#__PURE__*/createIcon(dataEyeSlashSolid);
var IconEyeSlashSolid$1 = IconEyeSlashSolid;

var IconEyeSolid = /*#__PURE__*/createIcon(dataEyeSolid);
var IconEyeSolid$1 = IconEyeSolid;

var IconEyeTracking = /*#__PURE__*/createIcon(dataEyeTracking);
var IconEyeTracking$1 = IconEyeTracking;

var IconEyeTrackingSolid = /*#__PURE__*/createIcon(dataEyeTrackingSolid);
var IconEyeTrackingSolid$1 = IconEyeTrackingSolid;

var IconEyedropper = /*#__PURE__*/createIcon(dataEyedropper);
var IconEyedropper$1 = IconEyedropper;

var IconFastForward = /*#__PURE__*/createIcon(dataFastForward);
var IconFastForward$1 = IconFastForward;

var IconFastRewind = /*#__PURE__*/createIcon(dataFastRewind);
var IconFastRewind$1 = IconFastRewind;

var IconFeed = /*#__PURE__*/createIcon(dataFeed);
var IconFeed$1 = IconFeed;

var IconFeedSolid = /*#__PURE__*/createIcon(dataFeedSolid);
var IconFeedSolid$1 = IconFeedSolid;

var IconFeedbackSolid = /*#__PURE__*/createIcon(dataFeedbackSolid);
var IconFeedbackSolid$1 = IconFeedbackSolid;

var IconFile = /*#__PURE__*/createIcon(dataFile);
var IconFile$1 = IconFile;

var IconFileAdd = /*#__PURE__*/createIcon(dataFileAdd);
var IconFileAdd$1 = IconFileAdd;

var IconFileAddSolid = /*#__PURE__*/createIcon(dataFileAddSolid);
var IconFileAddSolid$1 = IconFileAddSolid;

var IconFileEdit = /*#__PURE__*/createIcon(dataFileEdit);
var IconFileEdit$1 = IconFileEdit;

var IconFileEditSolid = /*#__PURE__*/createIcon(dataFileEditSolid);
var IconFileEditSolid$1 = IconFileEditSolid;

var IconFileError = /*#__PURE__*/createIcon(dataFileError);
var IconFileError$1 = IconFileError;

var IconFileErrorSolid = /*#__PURE__*/createIcon(dataFileErrorSolid);
var IconFileErrorSolid$1 = IconFileErrorSolid;

var IconFileSolid = /*#__PURE__*/createIcon(dataFileSolid);
var IconFileSolid$1 = IconFileSolid;

var IconFilm = /*#__PURE__*/createIcon(dataFilm);
var IconFilm$1 = IconFilm;

var IconFilmSolid = /*#__PURE__*/createIcon(dataFilmSolid);
var IconFilmSolid$1 = IconFilmSolid;

var IconFilter = /*#__PURE__*/createIcon(dataFilter);
var IconFilter$1 = IconFilter;

var IconFilterSolid = /*#__PURE__*/createIcon(dataFilterSolid);
var IconFilterSolid$1 = IconFilterSolid;

var IconFireSolid = /*#__PURE__*/createIcon(dataFireSolid);
var IconFireSolid$1 = IconFireSolid;

var IconFitWidth = /*#__PURE__*/createIcon(dataFitWidth);
var IconFitWidth$1 = IconFitWidth;

var IconFlag = /*#__PURE__*/createIcon(dataFlag);
var IconFlag$1 = IconFlag;

var IconFlagSolid = /*#__PURE__*/createIcon(dataFlagSolid);
var IconFlagSolid$1 = IconFlagSolid;

var IconFolder = /*#__PURE__*/createIcon(dataFolder);
var IconFolder$1 = IconFolder;

var IconFolderDownload = /*#__PURE__*/createIcon(dataFolderDownload);
var IconFolderDownload$1 = IconFolderDownload;

var IconFolderDownloadSolid = /*#__PURE__*/createIcon(dataFolderDownloadSolid);
var IconFolderDownloadSolid$1 = IconFolderDownloadSolid;

var IconFolderOpen = /*#__PURE__*/createIcon(dataFolderOpen);
var IconFolderOpen$1 = IconFolderOpen;

var IconFolderOpenSolid = /*#__PURE__*/createIcon(dataFolderOpenSolid);
var IconFolderOpenSolid$1 = IconFolderOpenSolid;

var IconFolderSolid = /*#__PURE__*/createIcon(dataFolderSolid);
var IconFolderSolid$1 = IconFolderSolid;

var IconFont = /*#__PURE__*/createIcon(dataFont);
var IconFont$1 = IconFont;

var IconFontSize = /*#__PURE__*/createIcon(dataFontSize);
var IconFontSize$1 = IconFontSize;

var IconFourDots = /*#__PURE__*/createIcon(dataFourDots);
var IconFourDots$1 = IconFourDots;

var IconFourQuarterCircles = /*#__PURE__*/createIcon(dataFourQuarterCircles);
var IconFourQuarterCircles$1 = IconFourQuarterCircles;

var IconFourQuarterCirclesSolid = /*#__PURE__*/createIcon(dataFourQuarterCirclesSolid);
var IconFourQuarterCirclesSolid$1 = IconFourQuarterCirclesSolid;

var IconFrowningFace = /*#__PURE__*/createIcon(dataFrowningFace);
var IconFrowningFace$1 = IconFrowningFace;

var IconFrowningFaceSolid = /*#__PURE__*/createIcon(dataFrowningFaceSolid);
var IconFrowningFaceSolid$1 = IconFrowningFaceSolid;

var IconFullCircle = /*#__PURE__*/createIcon(dataFullCircle);
var IconFullCircle$1 = IconFullCircle;

var IconFullCircleSolid = /*#__PURE__*/createIcon(dataFullCircleSolid);
var IconFullCircleSolid$1 = IconFullCircleSolid;

var IconFullscreen = /*#__PURE__*/createIcon(dataFullscreen);
var IconFullscreen$1 = IconFullscreen;

var IconFullscreenExit = /*#__PURE__*/createIcon(dataFullscreenExit);
var IconFullscreenExit$1 = IconFullscreenExit;

var IconGallery = /*#__PURE__*/createIcon(dataGallery);
var IconGallery$1 = IconGallery;

var IconGallerySolid = /*#__PURE__*/createIcon(dataGallerySolid);
var IconGallerySolid$1 = IconGallerySolid;

var IconGamepad = /*#__PURE__*/createIcon(dataGamepad);
var IconGamepad$1 = IconGamepad;

var IconGamepadSolid = /*#__PURE__*/createIcon(dataGamepadSolid);
var IconGamepadSolid$1 = IconGamepadSolid;

var IconGateway = /*#__PURE__*/createIcon(dataGateway);
var IconGateway$1 = IconGateway;

var IconGatewaySolid = /*#__PURE__*/createIcon(dataGatewaySolid);
var IconGatewaySolid$1 = IconGatewaySolid;

var IconGift = /*#__PURE__*/createIcon(dataGift);
var IconGift$1 = IconGift;

var IconGiftSolid = /*#__PURE__*/createIcon(dataGiftSolid);
var IconGiftSolid$1 = IconGiftSolid;

var IconGirl = /*#__PURE__*/createIcon(dataGirl);
var IconGirl$1 = IconGirl;

var IconGirlSolid = /*#__PURE__*/createIcon(dataGirlSolid);
var IconGirlSolid$1 = IconGirlSolid;

var IconGradeCircle = /*#__PURE__*/createIcon(dataGradeCircle);
var IconGradeCircle$1 = IconGradeCircle;

var IconGradeCircleSolid = /*#__PURE__*/createIcon(dataGradeCircleSolid);
var IconGradeCircleSolid$1 = IconGradeCircleSolid;

var IconHamburger = /*#__PURE__*/createIcon(dataHamburger);
var IconHamburger$1 = IconHamburger;

var IconHammerSolid = /*#__PURE__*/createIcon(dataHammerSolid);
var IconHammerSolid$1 = IconHammerSolid;

var IconHeadphones = /*#__PURE__*/createIcon(dataHeadphones);
var IconHeadphones$1 = IconHeadphones;

var IconHeadphonesSolid = /*#__PURE__*/createIcon(dataHeadphonesSolid);
var IconHeadphonesSolid$1 = IconHeadphonesSolid;

var IconHeart = /*#__PURE__*/createIcon(dataHeart);
var IconHeart$1 = IconHeart;

var IconHeartCancel = /*#__PURE__*/createIcon(dataHeartCancel);
var IconHeartCancel$1 = IconHeartCancel;

var IconHeartCancelSolid = /*#__PURE__*/createIcon(dataHeartCancelSolid);
var IconHeartCancelSolid$1 = IconHeartCancelSolid;

var IconHeartHandshakeSolid = /*#__PURE__*/createIcon(dataHeartHandshakeSolid);
var IconHeartHandshakeSolid$1 = IconHeartHandshakeSolid;

var IconHeartSolid = /*#__PURE__*/createIcon(dataHeartSolid);
var IconHeartSolid$1 = IconHeartSolid;

var IconHeteronymSquare = /*#__PURE__*/createIcon(dataHeteronymSquare);
var IconHeteronymSquare$1 = IconHeteronymSquare;

var IconHexagonSolid = /*#__PURE__*/createIcon(dataHexagonSolid);
var IconHexagonSolid$1 = IconHexagonSolid;

var IconHierarchy = /*#__PURE__*/createIcon(dataHierarchy);
var IconHierarchy$1 = IconHierarchy;

var IconHierarchySolid = /*#__PURE__*/createIcon(dataHierarchySolid);
var IconHierarchySolid$1 = IconHierarchySolid;

var IconHighSquare = /*#__PURE__*/createIcon(dataHighSquare);
var IconHighSquare$1 = IconHighSquare;

var IconHighSquareSolid = /*#__PURE__*/createIcon(dataHighSquareSolid);
var IconHighSquareSolid$1 = IconHighSquareSolid;

var IconHome = /*#__PURE__*/createIcon(dataHome);
var IconHome$1 = IconHome;

var IconHomeAltSolid = /*#__PURE__*/createIcon(dataHomeAltSolid);
var IconHomeAltSolid$1 = IconHomeAltSolid;

var IconHomeSolid = /*#__PURE__*/createIcon(dataHomeSolid);
var IconHomeSolid$1 = IconHomeSolid;

var IconHospital = /*#__PURE__*/createIcon(dataHospital);
var IconHospital$1 = IconHospital;

var IconHospitalSolid = /*#__PURE__*/createIcon(dataHospitalSolid);
var IconHospitalSolid$1 = IconHospitalSolid;

var IconHourglass = /*#__PURE__*/createIcon(dataHourglass);
var IconHourglass$1 = IconHourglass;

var IconHourglassSolid = /*#__PURE__*/createIcon(dataHourglassSolid);
var IconHourglassSolid$1 = IconHourglassSolid;

var IconHouse = /*#__PURE__*/createIcon(dataHouse);
var IconHouse$1 = IconHouse;

var IconHouseSolid = /*#__PURE__*/createIcon(dataHouseSolid);
var IconHouseSolid$1 = IconHouseSolid;

var IconIdCard = /*#__PURE__*/createIcon(dataIdCard);
var IconIdCard$1 = IconIdCard;

var IconIdCardBack = /*#__PURE__*/createIcon(dataIdCardBack);
var IconIdCardBack$1 = IconIdCardBack;

var IconIdCardBackSolid = /*#__PURE__*/createIcon(dataIdCardBackSolid);
var IconIdCardBackSolid$1 = IconIdCardBackSolid;

var IconIdCardSolid = /*#__PURE__*/createIcon(dataIdCardSolid);
var IconIdCardSolid$1 = IconIdCardSolid;

var IconIdCircle = /*#__PURE__*/createIcon(dataIdCircle);
var IconIdCircle$1 = IconIdCircle;

var IconIdSquare = /*#__PURE__*/createIcon(dataIdSquare);
var IconIdSquare$1 = IconIdSquare;

var IconImage = /*#__PURE__*/createIcon(dataImage);
var IconImage$1 = IconImage;

var IconImageAdd = /*#__PURE__*/createIcon(dataImageAdd);
var IconImageAdd$1 = IconImageAdd;

var IconImageDesktopSolid = /*#__PURE__*/createIcon(dataImageDesktopSolid);
var IconImageDesktopSolid$1 = IconImageDesktopSolid;

var IconImageSolid = /*#__PURE__*/createIcon(dataImageSolid);
var IconImageSolid$1 = IconImageSolid;

var IconImageStar = /*#__PURE__*/createIcon(dataImageStar);
var IconImageStar$1 = IconImageStar;

var IconImageStarSolid = /*#__PURE__*/createIcon(dataImageStarSolid);
var IconImageStarSolid$1 = IconImageStarSolid;

var IconImageUpload = /*#__PURE__*/createIcon(dataImageUpload);
var IconImageUpload$1 = IconImageUpload;

var IconImport = /*#__PURE__*/createIcon(dataImport);
var IconImport$1 = IconImport;

var IconIndent = /*#__PURE__*/createIcon(dataIndent);
var IconIndent$1 = IconIndent;

var IconInfoCircle = /*#__PURE__*/createIcon(dataInfoCircle);
var IconInfoCircle$1 = IconInfoCircle;

var IconInfoCircleSolid = /*#__PURE__*/createIcon(dataInfoCircleSolid);
var IconInfoCircleSolid$1 = IconInfoCircleSolid;

var IconInfoflow = /*#__PURE__*/createIcon(dataInfoflow);
var IconInfoflow$1 = IconInfoflow;

var IconIntelligence = /*#__PURE__*/createIcon(dataIntelligence);
var IconIntelligence$1 = IconIntelligence;

var IconIntelligenceSolid = /*#__PURE__*/createIcon(dataIntelligenceSolid);
var IconIntelligenceSolid$1 = IconIntelligenceSolid;

var IconIntelligentPrompt = /*#__PURE__*/createIcon(dataIntelligentPrompt);
var IconIntelligentPrompt$1 = IconIntelligentPrompt;

var IconInvoice = /*#__PURE__*/createIcon(dataInvoice);
var IconInvoice$1 = IconInvoice;

var IconInvoiceSolid = /*#__PURE__*/createIcon(dataInvoiceSolid);
var IconInvoiceSolid$1 = IconInvoiceSolid;

var IconItalic = /*#__PURE__*/createIcon(dataItalic);
var IconItalic$1 = IconItalic;

var IconKeyCommand = /*#__PURE__*/createIcon(dataKeyCommand);
var IconKeyCommand$1 = IconKeyCommand;

var IconKeyDelete = /*#__PURE__*/createIcon(dataKeyDelete);
var IconKeyDelete$1 = IconKeyDelete;

var IconKeyShift = /*#__PURE__*/createIcon(dataKeyShift);
var IconKeyShift$1 = IconKeyShift;

var IconKeyboard = /*#__PURE__*/createIcon(dataKeyboard);
var IconKeyboard$1 = IconKeyboard;

var IconLandingPageSolid = /*#__PURE__*/createIcon(dataLandingPageSolid);
var IconLandingPageSolid$1 = IconLandingPageSolid;

var IconLayer = /*#__PURE__*/createIcon(dataLayer);
var IconLayer$1 = IconLayer;

var IconLayerSolid = /*#__PURE__*/createIcon(dataLayerSolid);
var IconLayerSolid$1 = IconLayerSolid;

var IconLayout = /*#__PURE__*/createIcon(dataLayout);
var IconLayout$1 = IconLayout;

var IconLayoutSolid = /*#__PURE__*/createIcon(dataLayoutSolid);
var IconLayoutSolid$1 = IconLayoutSolid;

var IconLetterSpacing = /*#__PURE__*/createIcon(dataLetterSpacing);
var IconLetterSpacing$1 = IconLetterSpacing;

var IconLightning = /*#__PURE__*/createIcon(dataLightning);
var IconLightning$1 = IconLightning;

var IconLightningSolid = /*#__PURE__*/createIcon(dataLightningSolid);
var IconLightningSolid$1 = IconLightningSolid;

var IconLineChart = /*#__PURE__*/createIcon(dataLineChart);
var IconLineChart$1 = IconLineChart;

var IconLineChartAlt = /*#__PURE__*/createIcon(dataLineChartAlt);
var IconLineChartAlt$1 = IconLineChartAlt;

var IconLineChartAltSolid = /*#__PURE__*/createIcon(dataLineChartAltSolid);
var IconLineChartAltSolid$1 = IconLineChartAltSolid;

var IconLineChartSolid = /*#__PURE__*/createIcon(dataLineChartSolid);
var IconLineChartSolid$1 = IconLineChartSolid;

var IconLineHeight = /*#__PURE__*/createIcon(dataLineHeight);
var IconLineHeight$1 = IconLineHeight;

var IconLink = /*#__PURE__*/createIcon(dataLink);
var IconLink$1 = IconLink;

var IconLinkAlt = /*#__PURE__*/createIcon(dataLinkAlt);
var IconLinkAlt$1 = IconLinkAlt;

var IconLinkAltSolid = /*#__PURE__*/createIcon(dataLinkAltSolid);
var IconLinkAltSolid$1 = IconLinkAltSolid;

var IconListChecked = /*#__PURE__*/createIcon(dataListChecked);
var IconListChecked$1 = IconListChecked;

var IconListOrdered = /*#__PURE__*/createIcon(dataListOrdered);
var IconListOrdered$1 = IconListOrdered;

var IconListUnordered = /*#__PURE__*/createIcon(dataListUnordered);
var IconListUnordered$1 = IconListUnordered;

var IconLoading = /*#__PURE__*/createIcon(dataLoading);
var IconLoading$1 = IconLoading;

var IconLocation = /*#__PURE__*/createIcon(dataLocation);
var IconLocation$1 = IconLocation;

var IconLocationCopy = /*#__PURE__*/createIcon(dataLocationCopy);
var IconLocationCopy$1 = IconLocationCopy;

var IconLocationCopySolid = /*#__PURE__*/createIcon(dataLocationCopySolid);
var IconLocationCopySolid$1 = IconLocationCopySolid;

var IconLocationPin = /*#__PURE__*/createIcon(dataLocationPin);
var IconLocationPin$1 = IconLocationPin;

var IconLocationPinSolid = /*#__PURE__*/createIcon(dataLocationPinSolid);
var IconLocationPinSolid$1 = IconLocationPinSolid;

var IconLocationSolid = /*#__PURE__*/createIcon(dataLocationSolid);
var IconLocationSolid$1 = IconLocationSolid;

var IconLock = /*#__PURE__*/createIcon(dataLock);
var IconLock$1 = IconLock;

var IconLockSolid = /*#__PURE__*/createIcon(dataLockSolid);
var IconLockSolid$1 = IconLockSolid;

var IconLongVideo = /*#__PURE__*/createIcon(dataLongVideo);
var IconLongVideo$1 = IconLongVideo;

var IconLongVideoSolid = /*#__PURE__*/createIcon(dataLongVideoSolid);
var IconLongVideoSolid$1 = IconLongVideoSolid;

var IconLowSquare = /*#__PURE__*/createIcon(dataLowSquare);
var IconLowSquare$1 = IconLowSquare;

var IconLowSquareSolid = /*#__PURE__*/createIcon(dataLowSquareSolid);
var IconLowSquareSolid$1 = IconLowSquareSolid;

var IconMagicWand = /*#__PURE__*/createIcon(dataMagicWand);
var IconMagicWand$1 = IconMagicWand;

var IconMagicWandSolid = /*#__PURE__*/createIcon(dataMagicWandSolid);
var IconMagicWandSolid$1 = IconMagicWandSolid;

var IconMagnet = /*#__PURE__*/createIcon(dataMagnet);
var IconMagnet$1 = IconMagnet;

var IconMagnetSolid = /*#__PURE__*/createIcon(dataMagnetSolid);
var IconMagnetSolid$1 = IconMagnetSolid;

var IconMarket = /*#__PURE__*/createIcon(dataMarket);
var IconMarket$1 = IconMarket;

var IconMarketSolid = /*#__PURE__*/createIcon(dataMarketSolid);
var IconMarketSolid$1 = IconMarketSolid;

var IconMediaAdd = /*#__PURE__*/createIcon(dataMediaAdd);
var IconMediaAdd$1 = IconMediaAdd;

var IconMedicalKit = /*#__PURE__*/createIcon(dataMedicalKit);
var IconMedicalKit$1 = IconMedicalKit;

var IconMedicalKitSolid = /*#__PURE__*/createIcon(dataMedicalKitSolid);
var IconMedicalKitSolid$1 = IconMedicalKitSolid;

var IconMediumSquare = /*#__PURE__*/createIcon(dataMediumSquare);
var IconMediumSquare$1 = IconMediumSquare;

var IconMediumSquareSolid = /*#__PURE__*/createIcon(dataMediumSquareSolid);
var IconMediumSquareSolid$1 = IconMediumSquareSolid;

var IconMenu = /*#__PURE__*/createIcon(dataMenu);
var IconMenu$1 = IconMenu;

var IconMigrate = /*#__PURE__*/createIcon(dataMigrate);
var IconMigrate$1 = IconMigrate;

var IconMigrateSolid = /*#__PURE__*/createIcon(dataMigrateSolid);
var IconMigrateSolid$1 = IconMigrateSolid;

var IconMiniAppBaidu = /*#__PURE__*/createIcon(dataMiniAppBaidu);
var IconMiniAppBaidu$1 = IconMiniAppBaidu;

var IconMiniAppBaiduSolid = /*#__PURE__*/createIcon(dataMiniAppBaiduSolid);
var IconMiniAppBaiduSolid$1 = IconMiniAppBaiduSolid;

var IconMiniAppWechat = /*#__PURE__*/createIcon(dataMiniAppWechat);
var IconMiniAppWechat$1 = IconMiniAppWechat;

var IconMinimize = /*#__PURE__*/createIcon(dataMinimize);
var IconMinimize$1 = IconMinimize;

var IconMinus = /*#__PURE__*/createIcon(dataMinus);
var IconMinus$1 = IconMinus;

var IconMinusCircle = /*#__PURE__*/createIcon(dataMinusCircle);
var IconMinusCircle$1 = IconMinusCircle;

var IconMinusCircleSolid = /*#__PURE__*/createIcon(dataMinusCircleSolid);
var IconMinusCircleSolid$1 = IconMinusCircleSolid;

var IconMobileApp = /*#__PURE__*/createIcon(dataMobileApp);
var IconMobileApp$1 = IconMobileApp;

var IconMobileAppSolid = /*#__PURE__*/createIcon(dataMobileAppSolid);
var IconMobileAppSolid$1 = IconMobileAppSolid;

var IconMotionGraphics = /*#__PURE__*/createIcon(dataMotionGraphics);
var IconMotionGraphics$1 = IconMotionGraphics;

var IconMove = /*#__PURE__*/createIcon(dataMove);
var IconMove$1 = IconMove;

var IconMovieSolid = /*#__PURE__*/createIcon(dataMovieSolid);
var IconMovieSolid$1 = IconMovieSolid;

var IconMusic = /*#__PURE__*/createIcon(dataMusic);
var IconMusic$1 = IconMusic;

var IconMusicSolid = /*#__PURE__*/createIcon(dataMusicSolid);
var IconMusicSolid$1 = IconMusicSolid;

var IconMute = /*#__PURE__*/createIcon(dataMute);
var IconMute$1 = IconMute;

var IconMuteSolid = /*#__PURE__*/createIcon(dataMuteSolid);
var IconMuteSolid$1 = IconMuteSolid;

var IconNeutralFace = /*#__PURE__*/createIcon(dataNeutralFace);
var IconNeutralFace$1 = IconNeutralFace;

var IconNeutralFaceSolid = /*#__PURE__*/createIcon(dataNeutralFaceSolid);
var IconNeutralFaceSolid$1 = IconNeutralFaceSolid;

var IconOneToOne = /*#__PURE__*/createIcon(dataOneToOne);
var IconOneToOne$1 = IconOneToOne;

var IconOneToOneSolid = /*#__PURE__*/createIcon(dataOneToOneSolid);
var IconOneToOneSolid$1 = IconOneToOneSolid;

var IconOrder = /*#__PURE__*/createIcon(dataOrder);
var IconOrder$1 = IconOrder;

var IconOrderSolid = /*#__PURE__*/createIcon(dataOrderSolid);
var IconOrderSolid$1 = IconOrderSolid;

var IconOutdent = /*#__PURE__*/createIcon(dataOutdent);
var IconOutdent$1 = IconOutdent;

var IconOutstanding = /*#__PURE__*/createIcon(dataOutstanding);
var IconOutstanding$1 = IconOutstanding;

var IconOutstandingSolid = /*#__PURE__*/createIcon(dataOutstandingSolid);
var IconOutstandingSolid$1 = IconOutstandingSolid;

var IconPackageUpload = /*#__PURE__*/createIcon(dataPackageUpload);
var IconPackageUpload$1 = IconPackageUpload;

var IconPackageUploadSolid = /*#__PURE__*/createIcon(dataPackageUploadSolid);
var IconPackageUploadSolid$1 = IconPackageUploadSolid;

var IconPaintBucket = /*#__PURE__*/createIcon(dataPaintBucket);
var IconPaintBucket$1 = IconPaintBucket;

var IconPaintBucketSolid = /*#__PURE__*/createIcon(dataPaintBucketSolid);
var IconPaintBucketSolid$1 = IconPaintBucketSolid;

var IconPaperClip = /*#__PURE__*/createIcon(dataPaperClip);
var IconPaperClip$1 = IconPaperClip;

var IconPaperPlane = /*#__PURE__*/createIcon(dataPaperPlane);
var IconPaperPlane$1 = IconPaperPlane;

var IconPaperPlaneSend = /*#__PURE__*/createIcon(dataPaperPlaneSend);
var IconPaperPlaneSend$1 = IconPaperPlaneSend;

var IconPaperPlaneSendSolid = /*#__PURE__*/createIcon(dataPaperPlaneSendSolid);
var IconPaperPlaneSendSolid$1 = IconPaperPlaneSendSolid;

var IconPaperPlaneSolid = /*#__PURE__*/createIcon(dataPaperPlaneSolid);
var IconPaperPlaneSolid$1 = IconPaperPlaneSolid;

var IconPaste = /*#__PURE__*/createIcon(dataPaste);
var IconPaste$1 = IconPaste;

var IconPasteImageSolid = /*#__PURE__*/createIcon(dataPasteImageSolid);
var IconPasteImageSolid$1 = IconPasteImageSolid;

var IconPasteSolid = /*#__PURE__*/createIcon(dataPasteSolid);
var IconPasteSolid$1 = IconPasteSolid;

var IconPath = /*#__PURE__*/createIcon(dataPath);
var IconPath$1 = IconPath;

var IconPathSolid = /*#__PURE__*/createIcon(dataPathSolid);
var IconPathSolid$1 = IconPathSolid;

var IconPause = /*#__PURE__*/createIcon(dataPause);
var IconPause$1 = IconPause;

var IconPauseCircle = /*#__PURE__*/createIcon(dataPauseCircle);
var IconPauseCircle$1 = IconPauseCircle;

var IconPauseCircleSolid = /*#__PURE__*/createIcon(dataPauseCircleSolid);
var IconPauseCircleSolid$1 = IconPauseCircleSolid;

var IconPenWrite = /*#__PURE__*/createIcon(dataPenWrite);
var IconPenWrite$1 = IconPenWrite;

var IconPenWriteSolid = /*#__PURE__*/createIcon(dataPenWriteSolid);
var IconPenWriteSolid$1 = IconPenWriteSolid;

var IconPencil = /*#__PURE__*/createIcon(dataPencil);
var IconPencil$1 = IconPencil;

var IconPencilSolid = /*#__PURE__*/createIcon(dataPencilSolid);
var IconPencilSolid$1 = IconPencilSolid;

var IconPhone = /*#__PURE__*/createIcon(dataPhone);
var IconPhone$1 = IconPhone;

var IconPhoneCall = /*#__PURE__*/createIcon(dataPhoneCall);
var IconPhoneCall$1 = IconPhoneCall;

var IconPhoneCallSolid = /*#__PURE__*/createIcon(dataPhoneCallSolid);
var IconPhoneCallSolid$1 = IconPhoneCallSolid;

var IconPhoneEye = /*#__PURE__*/createIcon(dataPhoneEye);
var IconPhoneEye$1 = IconPhoneEye;

var IconPhoneEyeSolid = /*#__PURE__*/createIcon(dataPhoneEyeSolid);
var IconPhoneEyeSolid$1 = IconPhoneEyeSolid;

var IconPhoneSolid = /*#__PURE__*/createIcon(dataPhoneSolid);
var IconPhoneSolid$1 = IconPhoneSolid;

var IconPieChart = /*#__PURE__*/createIcon(dataPieChart);
var IconPieChart$1 = IconPieChart;

var IconPieChartSolid = /*#__PURE__*/createIcon(dataPieChartSolid);
var IconPieChartSolid$1 = IconPieChartSolid;

var IconPinSlant = /*#__PURE__*/createIcon(dataPinSlant);
var IconPinSlant$1 = IconPinSlant;

var IconPinSolid = /*#__PURE__*/createIcon(dataPinSolid);
var IconPinSolid$1 = IconPinSolid;

var IconPlay = /*#__PURE__*/createIcon(dataPlay);
var IconPlay$1 = IconPlay;

var IconPlayCircle = /*#__PURE__*/createIcon(dataPlayCircle);
var IconPlayCircle$1 = IconPlayCircle;

var IconPlayCircleSolid = /*#__PURE__*/createIcon(dataPlayCircleSolid);
var IconPlayCircleSolid$1 = IconPlayCircleSolid;

var IconPlus = /*#__PURE__*/createIcon(dataPlus);
var IconPlus$1 = IconPlus;

var IconPlusCircle = /*#__PURE__*/createIcon(dataPlusCircle);
var IconPlusCircle$1 = IconPlusCircle;

var IconPlusCircleSolid = /*#__PURE__*/createIcon(dataPlusCircleSolid);
var IconPlusCircleSolid$1 = IconPlusCircleSolid;

var IconPlusSquare = /*#__PURE__*/createIcon(dataPlusSquare);
var IconPlusSquare$1 = IconPlusSquare;

var IconPlusSquareSolid = /*#__PURE__*/createIcon(dataPlusSquareSolid);
var IconPlusSquareSolid$1 = IconPlusSquareSolid;

var IconPowerOff = /*#__PURE__*/createIcon(dataPowerOff);
var IconPowerOff$1 = IconPowerOff;

var IconPrinterSolid = /*#__PURE__*/createIcon(dataPrinterSolid);
var IconPrinterSolid$1 = IconPrinterSolid;

var IconPuzzlePiece = /*#__PURE__*/createIcon(dataPuzzlePiece);
var IconPuzzlePiece$1 = IconPuzzlePiece;

var IconPuzzlePieceSolid = /*#__PURE__*/createIcon(dataPuzzlePieceSolid);
var IconPuzzlePieceSolid$1 = IconPuzzlePieceSolid;

var IconPvShield = /*#__PURE__*/createIcon(dataPvShield);
var IconPvShield$1 = IconPvShield;

var IconPvShieldSolid = /*#__PURE__*/createIcon(dataPvShieldSolid);
var IconPvShieldSolid$1 = IconPvShieldSolid;

var IconQrcode = /*#__PURE__*/createIcon(dataQrcode);
var IconQrcode$1 = IconQrcode;

var IconQualityCircle = /*#__PURE__*/createIcon(dataQualityCircle);
var IconQualityCircle$1 = IconQualityCircle;

var IconQualityCircleSolid = /*#__PURE__*/createIcon(dataQualityCircleSolid);
var IconQualityCircleSolid$1 = IconQualityCircleSolid;

var IconQuestionCircle = /*#__PURE__*/createIcon(dataQuestionCircle);
var IconQuestionCircle$1 = IconQuestionCircle;

var IconQuestionCircleSolid = /*#__PURE__*/createIcon(dataQuestionCircleSolid);
var IconQuestionCircleSolid$1 = IconQuestionCircleSolid;

var IconQuestionComment = /*#__PURE__*/createIcon(dataQuestionComment);
var IconQuestionComment$1 = IconQuestionComment;

var IconQuestionCommentSolid = /*#__PURE__*/createIcon(dataQuestionCommentSolid);
var IconQuestionCommentSolid$1 = IconQuestionCommentSolid;

var IconRecommendSquare = /*#__PURE__*/createIcon(dataRecommendSquare);
var IconRecommendSquare$1 = IconRecommendSquare;

var IconRecommendSquareSolid = /*#__PURE__*/createIcon(dataRecommendSquareSolid);
var IconRecommendSquareSolid$1 = IconRecommendSquareSolid;

var IconRecommendation = /*#__PURE__*/createIcon(dataRecommendation);
var IconRecommendation$1 = IconRecommendation;

var IconRedo = /*#__PURE__*/createIcon(dataRedo);
var IconRedo$1 = IconRedo;

var IconRedoSolid = /*#__PURE__*/createIcon(dataRedoSolid);
var IconRedoSolid$1 = IconRedoSolid;

var IconReport = /*#__PURE__*/createIcon(dataReport);
var IconReport$1 = IconReport;

var IconReportBookmark = /*#__PURE__*/createIcon(dataReportBookmark);
var IconReportBookmark$1 = IconReportBookmark;

var IconReportBookmarkSolid = /*#__PURE__*/createIcon(dataReportBookmarkSolid);
var IconReportBookmarkSolid$1 = IconReportBookmarkSolid;

var IconReportCheck = /*#__PURE__*/createIcon(dataReportCheck);
var IconReportCheck$1 = IconReportCheck;

var IconReportCheckSolid = /*#__PURE__*/createIcon(dataReportCheckSolid);
var IconReportCheckSolid$1 = IconReportCheckSolid;

var IconReportSearch = /*#__PURE__*/createIcon(dataReportSearch);
var IconReportSearch$1 = IconReportSearch;

var IconReportSearchSolid = /*#__PURE__*/createIcon(dataReportSearchSolid);
var IconReportSearchSolid$1 = IconReportSearchSolid;

var IconReportSettings = /*#__PURE__*/createIcon(dataReportSettings);
var IconReportSettings$1 = IconReportSettings;

var IconReportSettingsSolid = /*#__PURE__*/createIcon(dataReportSettingsSolid);
var IconReportSettingsSolid$1 = IconReportSettingsSolid;

var IconReportSolid = /*#__PURE__*/createIcon(dataReportSolid);
var IconReportSolid$1 = IconReportSolid;

var IconReportStamp = /*#__PURE__*/createIcon(dataReportStamp);
var IconReportStamp$1 = IconReportStamp;

var IconReportStampSolid = /*#__PURE__*/createIcon(dataReportStampSolid);
var IconReportStampSolid$1 = IconReportStampSolid;

var IconReportStar = /*#__PURE__*/createIcon(dataReportStar);
var IconReportStar$1 = IconReportStar;

var IconReportStarSolid = /*#__PURE__*/createIcon(dataReportStarSolid);
var IconReportStarSolid$1 = IconReportStarSolid;

var IconReportTrendSettings = /*#__PURE__*/createIcon(dataReportTrendSettings);
var IconReportTrendSettings$1 = IconReportTrendSettings;

var IconReportTrendSettingsSolid = /*#__PURE__*/createIcon(dataReportTrendSettingsSolid);
var IconReportTrendSettingsSolid$1 = IconReportTrendSettingsSolid;

var IconReportUser = /*#__PURE__*/createIcon(dataReportUser);
var IconReportUser$1 = IconReportUser;

var IconReportUserSolid = /*#__PURE__*/createIcon(dataReportUserSolid);
var IconReportUserSolid$1 = IconReportUserSolid;

var IconRoad = /*#__PURE__*/createIcon(dataRoad);
var IconRoad$1 = IconRoad;

var IconRocketSolid = /*#__PURE__*/createIcon(dataRocketSolid);
var IconRocketSolid$1 = IconRocketSolid;

var IconRotateAnticlockwise = /*#__PURE__*/createIcon(dataRotateAnticlockwise);
var IconRotateAnticlockwise$1 = IconRotateAnticlockwise;

var IconRotateAnticlockwiseSolid = /*#__PURE__*/createIcon(dataRotateAnticlockwiseSolid);
var IconRotateAnticlockwiseSolid$1 = IconRotateAnticlockwiseSolid;

var IconRotateClockwise = /*#__PURE__*/createIcon(dataRotateClockwise);
var IconRotateClockwise$1 = IconRotateClockwise;

var IconRotateClockwiseSolid = /*#__PURE__*/createIcon(dataRotateClockwiseSolid);
var IconRotateClockwiseSolid$1 = IconRotateClockwiseSolid;

var IconSave = /*#__PURE__*/createIcon(dataSave);
var IconSave$1 = IconSave;

var IconSaveSolid = /*#__PURE__*/createIcon(dataSaveSolid);
var IconSaveSolid$1 = IconSaveSolid;

var IconScan = /*#__PURE__*/createIcon(dataScan);
var IconScan$1 = IconScan;

var IconSearch = /*#__PURE__*/createIcon(dataSearch);
var IconSearch$1 = IconSearch;

var IconSearchDesktop = /*#__PURE__*/createIcon(dataSearchDesktop);
var IconSearchDesktop$1 = IconSearchDesktop;

var IconSearchDesktopSolid = /*#__PURE__*/createIcon(dataSearchDesktopSolid);
var IconSearchDesktopSolid$1 = IconSearchDesktopSolid;

var IconSearchHistory = /*#__PURE__*/createIcon(dataSearchHistory);
var IconSearchHistory$1 = IconSearchHistory;

var IconSearchHistorySolid = /*#__PURE__*/createIcon(dataSearchHistorySolid);
var IconSearchHistorySolid$1 = IconSearchHistorySolid;

var IconSearchSolid = /*#__PURE__*/createIcon(dataSearchSolid);
var IconSearchSolid$1 = IconSearchSolid;

var IconSettings = /*#__PURE__*/createIcon(dataSettings);
var IconSettings$1 = IconSettings;

var IconSettingsSolid = /*#__PURE__*/createIcon(dataSettingsSolid);
var IconSettingsSolid$1 = IconSettingsSolid;

var IconShare = /*#__PURE__*/createIcon(dataShare);
var IconShare$1 = IconShare;

var IconShareAlt = /*#__PURE__*/createIcon(dataShareAlt);
var IconShareAlt$1 = IconShareAlt;

var IconShareAltSolid = /*#__PURE__*/createIcon(dataShareAltSolid);
var IconShareAltSolid$1 = IconShareAltSolid;

var IconShieldCheck = /*#__PURE__*/createIcon(dataShieldCheck);
var IconShieldCheck$1 = IconShieldCheck;

var IconShieldCheckSolid = /*#__PURE__*/createIcon(dataShieldCheckSolid);
var IconShieldCheckSolid$1 = IconShieldCheckSolid;

var IconShieldCnySolid = /*#__PURE__*/createIcon(dataShieldCnySolid);
var IconShieldCnySolid$1 = IconShieldCnySolid;

var IconShieldEllipsisSolid = /*#__PURE__*/createIcon(dataShieldEllipsisSolid);
var IconShieldEllipsisSolid$1 = IconShieldEllipsisSolid;

var IconShieldTimesSolid = /*#__PURE__*/createIcon(dataShieldTimesSolid);
var IconShieldTimesSolid$1 = IconShieldTimesSolid;

var IconShieldUser = /*#__PURE__*/createIcon(dataShieldUser);
var IconShieldUser$1 = IconShieldUser;

var IconShieldUserSolid = /*#__PURE__*/createIcon(dataShieldUserSolid);
var IconShieldUserSolid$1 = IconShieldUserSolid;

var IconShieldWave = /*#__PURE__*/createIcon(dataShieldWave);
var IconShieldWave$1 = IconShieldWave;

var IconShieldWaveSolid = /*#__PURE__*/createIcon(dataShieldWaveSolid);
var IconShieldWaveSolid$1 = IconShieldWaveSolid;

var IconShoppingBag = /*#__PURE__*/createIcon(dataShoppingBag);
var IconShoppingBag$1 = IconShoppingBag;

var IconShoppingBagSolid = /*#__PURE__*/createIcon(dataShoppingBagSolid);
var IconShoppingBagSolid$1 = IconShoppingBagSolid;

var IconShoppingCart = /*#__PURE__*/createIcon(dataShoppingCart);
var IconShoppingCart$1 = IconShoppingCart;

var IconShoppingCartSolid = /*#__PURE__*/createIcon(dataShoppingCartSolid);
var IconShoppingCartSolid$1 = IconShoppingCartSolid;

var IconShortVideo = /*#__PURE__*/createIcon(dataShortVideo);
var IconShortVideo$1 = IconShortVideo;

var IconShortVideoSolid = /*#__PURE__*/createIcon(dataShortVideoSolid);
var IconShortVideoSolid$1 = IconShortVideoSolid;

var IconShrink = /*#__PURE__*/createIcon(dataShrink);
var IconShrink$1 = IconShrink;

var IconSignOut = /*#__PURE__*/createIcon(dataSignOut);
var IconSignOut$1 = IconSignOut;

var IconSkipBackward = /*#__PURE__*/createIcon(dataSkipBackward);
var IconSkipBackward$1 = IconSkipBackward;

var IconSkipForward = /*#__PURE__*/createIcon(dataSkipForward);
var IconSkipForward$1 = IconSkipForward;

var IconSlidersSquare = /*#__PURE__*/createIcon(dataSlidersSquare);
var IconSlidersSquare$1 = IconSlidersSquare;

var IconSlidersSquareSolid = /*#__PURE__*/createIcon(dataSlidersSquareSolid);
var IconSlidersSquareSolid$1 = IconSlidersSquareSolid;

var IconSmiley = /*#__PURE__*/createIcon(dataSmiley);
var IconSmiley$1 = IconSmiley;

var IconSmileyComment = /*#__PURE__*/createIcon(dataSmileyComment);
var IconSmileyComment$1 = IconSmileyComment;

var IconSmileySolid = /*#__PURE__*/createIcon(dataSmileySolid);
var IconSmileySolid$1 = IconSmileySolid;

var IconSmileyStar = /*#__PURE__*/createIcon(dataSmileyStar);
var IconSmileyStar$1 = IconSmileyStar;

var IconSmileyStarSolid = /*#__PURE__*/createIcon(dataSmileyStarSolid);
var IconSmileyStarSolid$1 = IconSmileyStarSolid;

var IconSort = /*#__PURE__*/createIcon(dataSort);
var IconSort$1 = IconSort;

var IconSortAlt = /*#__PURE__*/createIcon(dataSortAlt);
var IconSortAlt$1 = IconSortAlt;

var IconSortAsc = /*#__PURE__*/createIcon(dataSortAsc);
var IconSortAsc$1 = IconSortAsc;

var IconSortDesc = /*#__PURE__*/createIcon(dataSortDesc);
var IconSortDesc$1 = IconSortDesc;

var IconSoundWave = /*#__PURE__*/createIcon(dataSoundWave);
var IconSoundWave$1 = IconSoundWave;

var IconSparklesSolid = /*#__PURE__*/createIcon(dataSparklesSolid);
var IconSparklesSolid$1 = IconSparklesSolid;

var IconSplit = /*#__PURE__*/createIcon(dataSplit);
var IconSplit$1 = IconSplit;

var IconSquareRotation = /*#__PURE__*/createIcon(dataSquareRotation);
var IconSquareRotation$1 = IconSquareRotation;

var IconSquareRotationSolid = /*#__PURE__*/createIcon(dataSquareRotationSolid);
var IconSquareRotationSolid$1 = IconSquareRotationSolid;

var IconStamp = /*#__PURE__*/createIcon(dataStamp);
var IconStamp$1 = IconStamp;

var IconStampSolid = /*#__PURE__*/createIcon(dataStampSolid);
var IconStampSolid$1 = IconStampSolid;

var IconStar = /*#__PURE__*/createIcon(dataStar);
var IconStar$1 = IconStar;

var IconStarDash = /*#__PURE__*/createIcon(dataStarDash);
var IconStarDash$1 = IconStarDash;

var IconStarDashSoild = /*#__PURE__*/createIcon(dataStarDashSoild);
/** @deprecated */

var IconStarDashSoild$1 = IconStarDashSoild;

var IconStarDashSolid = /*#__PURE__*/createIcon(dataStarDashSolid);
var IconStarDashSolid$1 = IconStarDashSolid;

var IconStarHalf = /*#__PURE__*/createIcon(dataStarHalf);
var IconStarHalf$1 = IconStarHalf;

var IconStarSolid = /*#__PURE__*/createIcon(dataStarSolid);
var IconStarSolid$1 = IconStarSolid;

var IconStop = /*#__PURE__*/createIcon(dataStop);
var IconStop$1 = IconStop;

var IconStopSolid = /*#__PURE__*/createIcon(dataStopSolid);
var IconStopSolid$1 = IconStopSolid;

var IconStrikethrough = /*#__PURE__*/createIcon(dataStrikethrough);
var IconStrikethrough$1 = IconStrikethrough;

var IconSwitch = /*#__PURE__*/createIcon(dataSwitch);
var IconSwitch$1 = IconSwitch;

var IconSync = /*#__PURE__*/createIcon(dataSync);
var IconSync$1 = IconSync;

var IconSyncCircle = /*#__PURE__*/createIcon(dataSyncCircle);
var IconSyncCircle$1 = IconSyncCircle;

var IconSyringe = /*#__PURE__*/createIcon(dataSyringe);
var IconSyringe$1 = IconSyringe;

var IconSyringesSolid = /*#__PURE__*/createIcon(dataSyringesSolid);
var IconSyringesSolid$1 = IconSyringesSolid;

var IconTag = /*#__PURE__*/createIcon(dataTag);
var IconTag$1 = IconTag;

var IconTagSolid = /*#__PURE__*/createIcon(dataTagSolid);
var IconTagSolid$1 = IconTagSolid;

var IconTeam = /*#__PURE__*/createIcon(dataTeam);
var IconTeam$1 = IconTeam;

var IconTeamSolid = /*#__PURE__*/createIcon(dataTeamSolid);
var IconTeamSolid$1 = IconTeamSolid;

var IconTelephone = /*#__PURE__*/createIcon(dataTelephone);
var IconTelephone$1 = IconTelephone;

var IconTelephoneSolid = /*#__PURE__*/createIcon(dataTelephoneSolid);
var IconTelephoneSolid$1 = IconTelephoneSolid;

var IconTemplate = /*#__PURE__*/createIcon(dataTemplate);
var IconTemplate$1 = IconTemplate;

var IconTemplateSolid = /*#__PURE__*/createIcon(dataTemplateSolid);
var IconTemplateSolid$1 = IconTemplateSolid;

var IconTextFlowerSquare = /*#__PURE__*/createIcon(dataTextFlowerSquare);
var IconTextFlowerSquare$1 = IconTextFlowerSquare;

var IconTextFlowerSquareSolid = /*#__PURE__*/createIcon(dataTextFlowerSquareSolid);
var IconTextFlowerSquareSolid$1 = IconTextFlowerSquareSolid;

var IconTextSquare = /*#__PURE__*/createIcon(dataTextSquare);
var IconTextSquare$1 = IconTextSquare;

var IconTextSquareAltSolid = /*#__PURE__*/createIcon(dataTextSquareAltSolid);
var IconTextSquareAltSolid$1 = IconTextSquareAltSolid;

var IconTextSquareSolid = /*#__PURE__*/createIcon(dataTextSquareSolid);
var IconTextSquareSolid$1 = IconTextSquareSolid;

var IconThumbDown = /*#__PURE__*/createIcon(dataThumbDown);
var IconThumbDown$1 = IconThumbDown;

var IconThumbDownSolid = /*#__PURE__*/createIcon(dataThumbDownSolid);
var IconThumbDownSolid$1 = IconThumbDownSolid;

var IconThumbUp = /*#__PURE__*/createIcon(dataThumbUp);
var IconThumbUp$1 = IconThumbUp;

var IconThumbUpSolid = /*#__PURE__*/createIcon(dataThumbUpSolid);
var IconThumbUpSolid$1 = IconThumbUpSolid;

var IconTimes = /*#__PURE__*/createIcon(dataTimes);
var IconTimes$1 = IconTimes;

var IconTimesCircle = /*#__PURE__*/createIcon(dataTimesCircle);
var IconTimesCircle$1 = IconTimesCircle;

var IconTimesCircleSolid = /*#__PURE__*/createIcon(dataTimesCircleSolid);
var IconTimesCircleSolid$1 = IconTimesCircleSolid;

var IconToolbox = /*#__PURE__*/createIcon(dataToolbox);
var IconToolbox$1 = IconToolbox;

var IconToolboxSolid = /*#__PURE__*/createIcon(dataToolboxSolid);
var IconToolboxSolid$1 = IconToolboxSolid;

var IconToolsSolid = /*#__PURE__*/createIcon(dataToolsSolid);
var IconToolsSolid$1 = IconToolsSolid;

var IconTrackCut = /*#__PURE__*/createIcon(dataTrackCut);
var IconTrackCut$1 = IconTrackCut;

var IconTrackFrameLast = /*#__PURE__*/createIcon(dataTrackFrameLast);
var IconTrackFrameLast$1 = IconTrackFrameLast;

var IconTrash = /*#__PURE__*/createIcon(dataTrash);
var IconTrash$1 = IconTrash;

var IconTrashSolid = /*#__PURE__*/createIcon(dataTrashSolid);
var IconTrashSolid$1 = IconTrashSolid;

var IconTravelEarthPlaneSolid = /*#__PURE__*/createIcon(dataTravelEarthPlaneSolid);
var IconTravelEarthPlaneSolid$1 = IconTravelEarthPlaneSolid;

var IconTreasureChest = /*#__PURE__*/createIcon(dataTreasureChest);
var IconTreasureChest$1 = IconTreasureChest;

var IconTreasureChestSolid = /*#__PURE__*/createIcon(dataTreasureChestSolid);
var IconTreasureChestSolid$1 = IconTreasureChestSolid;

var IconTrendDesktop = /*#__PURE__*/createIcon(dataTrendDesktop);
var IconTrendDesktop$1 = IconTrendDesktop;

var IconTrendDesktopSolid = /*#__PURE__*/createIcon(dataTrendDesktopSolid);
var IconTrendDesktopSolid$1 = IconTrendDesktopSolid;

var IconTrendMonitor = /*#__PURE__*/createIcon(dataTrendMonitor);
var IconTrendMonitor$1 = IconTrendMonitor;

var IconTrendMonitorSolid = /*#__PURE__*/createIcon(dataTrendMonitorSolid);
var IconTrendMonitorSolid$1 = IconTrendMonitorSolid;

var IconTrendPages = /*#__PURE__*/createIcon(dataTrendPages);
var IconTrendPages$1 = IconTrendPages;

var IconTrendPagesSolid = /*#__PURE__*/createIcon(dataTrendPagesSolid);
var IconTrendPagesSolid$1 = IconTrendPagesSolid;

var IconTrendReport = /*#__PURE__*/createIcon(dataTrendReport);
var IconTrendReport$1 = IconTrendReport;

var IconTrendReportSolid = /*#__PURE__*/createIcon(dataTrendReportSolid);
var IconTrendReportSolid$1 = IconTrendReportSolid;

var IconTrendStarSolid = /*#__PURE__*/createIcon(dataTrendStarSolid);
var IconTrendStarSolid$1 = IconTrendStarSolid;

var IconTrimLeft = /*#__PURE__*/createIcon(dataTrimLeft);
var IconTrimLeft$1 = IconTrimLeft;

var IconTrimRight = /*#__PURE__*/createIcon(dataTrimRight);
var IconTrimRight$1 = IconTrimRight;

var IconTrophy = /*#__PURE__*/createIcon(dataTrophy);
var IconTrophy$1 = IconTrophy;

var IconTrophySolid = /*#__PURE__*/createIcon(dataTrophySolid);
var IconTrophySolid$1 = IconTrophySolid;

var IconTruck = /*#__PURE__*/createIcon(dataTruck);
var IconTruck$1 = IconTruck;

var IconTruckSolid = /*#__PURE__*/createIcon(dataTruckSolid);
var IconTruckSolid$1 = IconTruckSolid;

var IconTv = /*#__PURE__*/createIcon(dataTv);
var IconTv$1 = IconTv;

var IconTvSolid = /*#__PURE__*/createIcon(dataTvSolid);
var IconTvSolid$1 = IconTvSolid;

var IconTwoHearts = /*#__PURE__*/createIcon(dataTwoHearts);
var IconTwoHearts$1 = IconTwoHearts;

var IconTwoHeartsSolid = /*#__PURE__*/createIcon(dataTwoHeartsSolid);
var IconTwoHeartsSolid$1 = IconTwoHeartsSolid;

var IconUnderline = /*#__PURE__*/createIcon(dataUnderline);
var IconUnderline$1 = IconUnderline;

var IconUndo = /*#__PURE__*/createIcon(dataUndo);
var IconUndo$1 = IconUndo;

var IconUndoSolid = /*#__PURE__*/createIcon(dataUndoSolid);
var IconUndoSolid$1 = IconUndoSolid;

var IconUnlink = /*#__PURE__*/createIcon(dataUnlink);
var IconUnlink$1 = IconUnlink;

var IconUnlock = /*#__PURE__*/createIcon(dataUnlock);
var IconUnlock$1 = IconUnlock;

var IconUnlockSolid = /*#__PURE__*/createIcon(dataUnlockSolid);
var IconUnlockSolid$1 = IconUnlockSolid;

var IconUpdateWave = /*#__PURE__*/createIcon(dataUpdateWave);
var IconUpdateWave$1 = IconUpdateWave;

var IconUpgrade = /*#__PURE__*/createIcon(dataUpgrade);
var IconUpgrade$1 = IconUpgrade;

var IconUpgradeSolid = /*#__PURE__*/createIcon(dataUpgradeSolid);
var IconUpgradeSolid$1 = IconUpgradeSolid;

var IconUpload = /*#__PURE__*/createIcon(dataUpload);
var IconUpload$1 = IconUpload;

var IconUploadDesktop = /*#__PURE__*/createIcon(dataUploadDesktop);
var IconUploadDesktop$1 = IconUploadDesktop;

var IconUploadDesktopSolid = /*#__PURE__*/createIcon(dataUploadDesktopSolid);
var IconUploadDesktopSolid$1 = IconUploadDesktopSolid;

var IconUser = /*#__PURE__*/createIcon(dataUser);
var IconUser$1 = IconUser;

var IconUserAuthorization = /*#__PURE__*/createIcon(dataUserAuthorization);
var IconUserAuthorization$1 = IconUserAuthorization;

var IconUserBookmark = /*#__PURE__*/createIcon(dataUserBookmark);
var IconUserBookmark$1 = IconUserBookmark;

var IconUserBookmarkSolid = /*#__PURE__*/createIcon(dataUserBookmarkSolid);
var IconUserBookmarkSolid$1 = IconUserBookmarkSolid;

var IconUserCard = /*#__PURE__*/createIcon(dataUserCard);
var IconUserCard$1 = IconUserCard;

var IconUserCardSolid = /*#__PURE__*/createIcon(dataUserCardSolid);
var IconUserCardSolid$1 = IconUserCardSolid;

var IconUserCircle = /*#__PURE__*/createIcon(dataUserCircle);
var IconUserCircle$1 = IconUserCircle;

var IconUserCircleSolid = /*#__PURE__*/createIcon(dataUserCircleSolid);
var IconUserCircleSolid$1 = IconUserCircleSolid;

var IconUserCombined = /*#__PURE__*/createIcon(dataUserCombined);
var IconUserCombined$1 = IconUserCombined;

var IconUserCombinedSolid = /*#__PURE__*/createIcon(dataUserCombinedSolid);
var IconUserCombinedSolid$1 = IconUserCombinedSolid;

var IconUserFilter = /*#__PURE__*/createIcon(dataUserFilter);
var IconUserFilter$1 = IconUserFilter;

var IconUserFilterSolid = /*#__PURE__*/createIcon(dataUserFilterSolid);
var IconUserFilterSolid$1 = IconUserFilterSolid;

var IconUserIntersection = /*#__PURE__*/createIcon(dataUserIntersection);
var IconUserIntersection$1 = IconUserIntersection;

var IconUserIntersectionSolid = /*#__PURE__*/createIcon(dataUserIntersectionSolid);
var IconUserIntersectionSolid$1 = IconUserIntersectionSolid;

var IconUserLabel = /*#__PURE__*/createIcon(dataUserLabel);
var IconUserLabel$1 = IconUserLabel;

var IconUserLabelSolid = /*#__PURE__*/createIcon(dataUserLabelSolid);
var IconUserLabelSolid$1 = IconUserLabelSolid;

var IconUserMobile = /*#__PURE__*/createIcon(dataUserMobile);
var IconUserMobile$1 = IconUserMobile;

var IconUserMobileSolid = /*#__PURE__*/createIcon(dataUserMobileSolid);
var IconUserMobileSolid$1 = IconUserMobileSolid;

var IconUserSearch = /*#__PURE__*/createIcon(dataUserSearch);
var IconUserSearch$1 = IconUserSearch;

var IconUserSearchSolid = /*#__PURE__*/createIcon(dataUserSearchSolid);
var IconUserSearchSolid$1 = IconUserSearchSolid;

var IconUserSettings = /*#__PURE__*/createIcon(dataUserSettings);
var IconUserSettings$1 = IconUserSettings;

var IconUserSettingsSolid = /*#__PURE__*/createIcon(dataUserSettingsSolid);
var IconUserSettingsSolid$1 = IconUserSettingsSolid;

var IconUserSolid = /*#__PURE__*/createIcon(dataUserSolid);
var IconUserSolid$1 = IconUserSolid;

var IconUserStar = /*#__PURE__*/createIcon(dataUserStar);
var IconUserStar$1 = IconUserStar;

var IconUserSync = /*#__PURE__*/createIcon(dataUserSync);
var IconUserSync$1 = IconUserSync;

var IconUserSyncSolid = /*#__PURE__*/createIcon(dataUserSyncSolid);
var IconUserSyncSolid$1 = IconUserSyncSolid;

var IconUserTieba = /*#__PURE__*/createIcon(dataUserTieba);
var IconUserTieba$1 = IconUserTieba;

var IconVideo = /*#__PURE__*/createIcon(dataVideo);
var IconVideo$1 = IconVideo;

var IconVideoAdd = /*#__PURE__*/createIcon(dataVideoAdd);
var IconVideoAdd$1 = IconVideoAdd;

var IconVideoCrop = /*#__PURE__*/createIcon(dataVideoCrop);
var IconVideoCrop$1 = IconVideoCrop;

var IconVideoCropSolid = /*#__PURE__*/createIcon(dataVideoCropSolid);
var IconVideoCropSolid$1 = IconVideoCropSolid;

var IconVideoFilm = /*#__PURE__*/createIcon(dataVideoFilm);
var IconVideoFilm$1 = IconVideoFilm;

var IconVideoFilmSolid = /*#__PURE__*/createIcon(dataVideoFilmSolid);
var IconVideoFilmSolid$1 = IconVideoFilmSolid;

var IconVideoFrameFirst = /*#__PURE__*/createIcon(dataVideoFrameFirst);
var IconVideoFrameFirst$1 = IconVideoFrameFirst;

var IconVideoHistory = /*#__PURE__*/createIcon(dataVideoHistory);
var IconVideoHistory$1 = IconVideoHistory;

var IconVideoHistorySolid = /*#__PURE__*/createIcon(dataVideoHistorySolid);
var IconVideoHistorySolid$1 = IconVideoHistorySolid;

var IconVideoSolid = /*#__PURE__*/createIcon(dataVideoSolid);
var IconVideoSolid$1 = IconVideoSolid;

var IconVideoUpload = /*#__PURE__*/createIcon(dataVideoUpload);
var IconVideoUpload$1 = IconVideoUpload;

var IconVolume = /*#__PURE__*/createIcon(dataVolume);
var IconVolume$1 = IconVolume;

var IconVolumeSolid = /*#__PURE__*/createIcon(dataVolumeSolid);
var IconVolumeSolid$1 = IconVolumeSolid;

var IconWhirlpool = /*#__PURE__*/createIcon(dataWhirlpool);
var IconWhirlpool$1 = IconWhirlpool;

var IconWhirlpoolSolid = /*#__PURE__*/createIcon(dataWhirlpoolSolid);
var IconWhirlpoolSolid$1 = IconWhirlpoolSolid;

var IconWoman = /*#__PURE__*/createIcon(dataWoman);
var IconWoman$1 = IconWoman;

var IconYaoSquare = /*#__PURE__*/createIcon(dataYaoSquare);
var IconYaoSquare$1 = IconYaoSquare;

var IconYingxiaotong = /*#__PURE__*/createIcon(dataYingxiaotong);
var IconYingxiaotong$1 = IconYingxiaotong;

var IconYingxiaotongSolid = /*#__PURE__*/createIcon(dataYingxiaotongSolid);
var IconYingxiaotongSolid$1 = IconYingxiaotongSolid;

var IconZoomIn = /*#__PURE__*/createIcon(dataZoomIn);
var IconZoomIn$1 = IconZoomIn;

var IconZoomInSolid = /*#__PURE__*/createIcon(dataZoomInSolid);
var IconZoomInSolid$1 = IconZoomInSolid;

var IconZoomOut = /*#__PURE__*/createIcon(dataZoomOut);
var IconZoomOut$1 = IconZoomOut;

var IconZoomOutSolid = /*#__PURE__*/createIcon(dataZoomOutSolid);
var IconZoomOutSolid$1 = IconZoomOutSolid;

export { IconAbTest$1 as IconAbTest, IconAbTestSolid$1 as IconAbTestSolid, IconAbstract$1 as IconAbstract, IconAbstractSolid$1 as IconAbstractSolid, IconAcademicCap$1 as IconAcademicCap, IconAcademicCapSolid$1 as IconAcademicCapSolid, IconAdDeliveryCircleSolid$1 as IconAdDeliveryCircleSolid, IconAddPauseSquare$1 as IconAddPauseSquare, IconAdjust$1 as IconAdjust, IconAfterSquare$1 as IconAfterSquare, IconAfterSquareSolid$1 as IconAfterSquareSolid, IconAi$1 as IconAi, IconAiBubble$1 as IconAiBubble, IconAiBubbleSolid$1 as IconAiBubbleSolid, IconAlignBottom$1 as IconAlignBottom, IconAlignCenter$1 as IconAlignCenter, IconAlignLeft$1 as IconAlignLeft, IconAlignRight$1 as IconAlignRight, IconAlignTop$1 as IconAlignTop, IconAndroid$1 as IconAndroid, IconAnticlockwise$1 as IconAnticlockwise, IconAppStore$1 as IconAppStore, IconApps$1 as IconApps, IconAppsSettings$1 as IconAppsSettings, IconAppsSettingsSolid$1 as IconAppsSettingsSolid, IconAppsSolid$1 as IconAppsSolid, IconArrowCurveDownRightSolid$1 as IconArrowCurveDownRightSolid, IconArrowCurveUpRightSolid$1 as IconArrowCurveUpRightSolid, IconArrowDown$1 as IconArrowDown, IconArrowDownLeft$1 as IconArrowDownLeft, IconArrowDownRight$1 as IconArrowDownRight, IconArrowDownSolid$1 as IconArrowDownSolid, IconArrowLeft$1 as IconArrowLeft, IconArrowLeftSolid$1 as IconArrowLeftSolid, IconArrowRight$1 as IconArrowRight, IconArrowRightSolid$1 as IconArrowRightSolid, IconArrowToBottom$1 as IconArrowToBottom, IconArrowToTop$1 as IconArrowToTop, IconArrowToTopSoild$1 as IconArrowToTopSoild, IconArrowToTopSolid$1 as IconArrowToTopSolid, IconArrowUUpLeft$1 as IconArrowUUpLeft, IconArrowUUpRight$1 as IconArrowUUpRight, IconArrowUp$1 as IconArrowUp, IconArrowUpSolid$1 as IconArrowUpSolid, IconAsterisk$1 as IconAsterisk, IconAttribute$1 as IconAttribute, IconAttributeSolid$1 as IconAttributeSolid, IconAudio$1 as IconAudio, IconAudioSolid$1 as IconAudioSolid, IconBabyBottle$1 as IconBabyBottle, IconBabyBottleSolid$1 as IconBabyBottleSolid, IconBackground$1 as IconBackground, IconBackgroundSolid$1 as IconBackgroundSolid, IconBackgroundSwitchSolid$1 as IconBackgroundSwitchSolid, IconBarChart$1 as IconBarChart, IconBarChartAlt$1 as IconBarChartAlt, IconBarChartAltSolid$1 as IconBarChartAltSolid, IconBarChartSolid$1 as IconBarChartSolid, IconBarChartSquare$1 as IconBarChartSquare, IconBarChartSquareSolid$1 as IconBarChartSquareSolid, IconBeforeSquare$1 as IconBeforeSquare, IconBeforeSquareSolid$1 as IconBeforeSquareSolid, IconBell$1 as IconBell, IconBellSolid$1 as IconBellSolid, IconBold$1 as IconBold, IconBook$1 as IconBook, IconBookBookmark$1 as IconBookBookmark, IconBookBookmarkCheckSolid$1 as IconBookBookmarkCheckSolid, IconBookBookmarkSolid$1 as IconBookBookmarkSolid, IconBookOpen$1 as IconBookOpen, IconBookSolid$1 as IconBookSolid, IconBookmark$1 as IconBookmark, IconBookmarkSolid$1 as IconBookmarkSolid, IconBooksBookmark$1 as IconBooksBookmark, IconBooksBookmarkSolid$1 as IconBooksBookmarkSolid, IconBox$1 as IconBox, IconBoxSolid$1 as IconBoxSolid, IconBrush$1 as IconBrush, IconBuilding$1 as IconBuilding, IconBuildingSolid$1 as IconBuildingSolid, IconBulb$1 as IconBulb, IconBulbDash$1 as IconBulbDash, IconBulbDashSolid$1 as IconBulbDashSolid, IconBulbSolid$1 as IconBulbSolid, IconBulbTrendSolid$1 as IconBulbTrendSolid, IconBullseye$1 as IconBullseye, IconBullseyeHit$1 as IconBullseyeHit, IconBullseyeHitSolid$1 as IconBullseyeHitSolid, IconCalendar$1 as IconCalendar, IconCalendarCny$1 as IconCalendarCny, IconCalendarCnySolid$1 as IconCalendarCnySolid, IconCalendarHeart$1 as IconCalendarHeart, IconCalendarHeartSolid$1 as IconCalendarHeartSolid, IconCalendarSolid$1 as IconCalendarSolid, IconCamera$1 as IconCamera, IconCameraAdd$1 as IconCameraAdd, IconCameraAddSolid$1 as IconCameraAddSolid, IconCameraSolid$1 as IconCameraSolid, IconCar$1 as IconCar, IconCarSolid$1 as IconCarSolid, IconCardSolid$1 as IconCardSolid, IconCaretDown$1 as IconCaretDown, IconCaretLeft$1 as IconCaretLeft, IconCaretRight$1 as IconCaretRight, IconCaretUp$1 as IconCaretUp, IconCaretsOpposite$1 as IconCaretsOpposite, IconCellphone$1 as IconCellphone, IconCellphoneSolid$1 as IconCellphoneSolid, IconChat$1 as IconChat, IconChatSolid$1 as IconChatSolid, IconCheck$1 as IconCheck, IconCheckCircle$1 as IconCheckCircle, IconCheckCircleSolid$1 as IconCheckCircleSolid, IconCheckDesktop$1 as IconCheckDesktop, IconCheckDesktopSolid$1 as IconCheckDesktopSolid, IconCheckSquare$1 as IconCheckSquare, IconCheckSquareSolid$1 as IconCheckSquareSolid, IconChevronDoubleDown$1 as IconChevronDoubleDown, IconChevronDoubleLeft$1 as IconChevronDoubleLeft, IconChevronDoubleRight$1 as IconChevronDoubleRight, IconChevronDoubleUp$1 as IconChevronDoubleUp, IconChevronDown$1 as IconChevronDown, IconChevronLeft$1 as IconChevronLeft, IconChevronLeftCircle$1 as IconChevronLeftCircle, IconChevronLeftCircleSolid$1 as IconChevronLeftCircleSolid, IconChevronRight$1 as IconChevronRight, IconChevronRightCircle$1 as IconChevronRightCircle, IconChevronRightCircleSolid$1 as IconChevronRightCircleSolid, IconChevronUp$1 as IconChevronUp, IconCircleExtend$1 as IconCircleExtend, IconCircleExtendSolid$1 as IconCircleExtendSolid, IconCircleRotation$1 as IconCircleRotation, IconCircleRotationSolid$1 as IconCircleRotationSolid, IconClock$1 as IconClock, IconClockSolid$1 as IconClockSolid, IconClockwise$1 as IconClockwise, IconCloudUploadSolid$1 as IconCloudUploadSolid, IconCnyCircle$1 as IconCnyCircle, IconCnyCircleSolid$1 as IconCnyCircleSolid, IconCnyRefund$1 as IconCnyRefund, IconCnyWallet$1 as IconCnyWallet, IconCnyWalletSolid$1 as IconCnyWalletSolid, IconCoin$1 as IconCoin, IconCoinDiamond$1 as IconCoinDiamond, IconCoinDiamondSolid$1 as IconCoinDiamondSolid, IconCoinSolid$1 as IconCoinSolid, IconColorPalette$1 as IconColorPalette, IconColorPaletteSolid$1 as IconColorPaletteSolid, IconCompass$1 as IconCompass, IconCompassSolid$1 as IconCompassSolid, IconComponent$1 as IconComponent, IconComponentSolid$1 as IconComponentSolid, IconCopy$1 as IconCopy, IconCopySolid$1 as IconCopySolid, IconCouponMinus$1 as IconCouponMinus, IconCouponMinusSolid$1 as IconCouponMinusSolid, IconCouponPercent$1 as IconCouponPercent, IconCouponPercentSolid$1 as IconCouponPercentSolid, IconCrop$1 as IconCrop, IconCropSolid$1 as IconCropSolid, IconCrown$1 as IconCrown, IconCrownSolid$1 as IconCrownSolid, IconCube$1 as IconCube, IconCubeEye$1 as IconCubeEye, IconCubeEyeSolid$1 as IconCubeEyeSolid, IconCubeSolid$1 as IconCubeSolid, IconCurveSquare$1 as IconCurveSquare, IconCurveSquareSolid$1 as IconCurveSquareSolid, IconCustomer$1 as IconCustomer, IconCustomerService$1 as IconCustomerService, IconCustomerSettings$1 as IconCustomerSettings, IconCustomerSettingsSolid$1 as IconCustomerSettingsSolid, IconCustomerSolid$1 as IconCustomerSolid, IconCut$1 as IconCut, IconCutSolid$1 as IconCutSolid, IconData$1 as IconData, IconDataMarket$1 as IconDataMarket, IconDataMarketSolid$1 as IconDataMarketSolid, IconDataSolid$1 as IconDataSolid, IconDatabase$1 as IconDatabase, IconDatabaseSolid$1 as IconDatabaseSolid, IconDecreaseWidth$1 as IconDecreaseWidth, IconDesktop$1 as IconDesktop, IconDesktopSolid$1 as IconDesktopSolid, IconDetailList$1 as IconDetailList, IconDetailListSolid$1 as IconDetailListSolid, IconDiamond$1 as IconDiamond, IconDiamondSolid$1 as IconDiamondSolid, IconDollarCircle$1 as IconDollarCircle, IconDollarCircleSolid$1 as IconDollarCircleSolid, IconDoubleCircle$1 as IconDoubleCircle, IconDoubleCircleSolid$1 as IconDoubleCircleSolid, IconDownload$1 as IconDownload, IconDragIndicator$1 as IconDragIndicator, IconEdit$1 as IconEdit, IconEditSolid$1 as IconEditSolid, IconElement$1 as IconElement, IconElementSolid$1 as IconElementSolid, IconEllipsis$1 as IconEllipsis, IconEllipsisCircle$1 as IconEllipsisCircle, IconEllipsisCircleSolid$1 as IconEllipsisCircleSolid, IconEllipsisVertical$1 as IconEllipsisVertical, IconEnglishComment$1 as IconEnglishComment, IconEnglishCommentSolid$1 as IconEnglishCommentSolid, IconEnvelope$1 as IconEnvelope, IconEnvelopeOpen$1 as IconEnvelopeOpen, IconEnvelopeOpenSolid$1 as IconEnvelopeOpenSolid, IconEnvelopeSolid$1 as IconEnvelopeSolid, IconExcellentBookmark$1 as IconExcellentBookmark, IconExcellentBookmarkSolid$1 as IconExcellentBookmarkSolid, IconExclamationCircle$1 as IconExclamationCircle, IconExclamationCircleSolid$1 as IconExclamationCircleSolid, IconExclamationTriangle$1 as IconExclamationTriangle, IconExclamationTriangleSolid$1 as IconExclamationTriangleSolid, IconExpand$1 as IconExpand, IconExpandAlt$1 as IconExpandAlt, IconExpandSquare$1 as IconExpandSquare, IconExpandSquareSolid$1 as IconExpandSquareSolid, IconExternalLink$1 as IconExternalLink, IconEye$1 as IconEye, IconEyeBright$1 as IconEyeBright, IconEyeBrightSolid$1 as IconEyeBrightSolid, IconEyeSlash$1 as IconEyeSlash, IconEyeSlashSolid$1 as IconEyeSlashSolid, IconEyeSolid$1 as IconEyeSolid, IconEyeTracking$1 as IconEyeTracking, IconEyeTrackingSolid$1 as IconEyeTrackingSolid, IconEyedropper$1 as IconEyedropper, IconFastForward$1 as IconFastForward, IconFastRewind$1 as IconFastRewind, IconFeed$1 as IconFeed, IconFeedSolid$1 as IconFeedSolid, IconFeedbackSolid$1 as IconFeedbackSolid, IconFile$1 as IconFile, IconFileAdd$1 as IconFileAdd, IconFileAddSolid$1 as IconFileAddSolid, IconFileEdit$1 as IconFileEdit, IconFileEditSolid$1 as IconFileEditSolid, IconFileError$1 as IconFileError, IconFileErrorSolid$1 as IconFileErrorSolid, IconFileSolid$1 as IconFileSolid, IconFilm$1 as IconFilm, IconFilmSolid$1 as IconFilmSolid, IconFilter$1 as IconFilter, IconFilterSolid$1 as IconFilterSolid, IconFireSolid$1 as IconFireSolid, IconFitWidth$1 as IconFitWidth, IconFlag$1 as IconFlag, IconFlagSolid$1 as IconFlagSolid, IconFolder$1 as IconFolder, IconFolderDownload$1 as IconFolderDownload, IconFolderDownloadSolid$1 as IconFolderDownloadSolid, IconFolderOpen$1 as IconFolderOpen, IconFolderOpenSolid$1 as IconFolderOpenSolid, IconFolderSolid$1 as IconFolderSolid, IconFont$1 as IconFont, IconFontSize$1 as IconFontSize, IconFourDots$1 as IconFourDots, IconFourQuarterCircles$1 as IconFourQuarterCircles, IconFourQuarterCirclesSolid$1 as IconFourQuarterCirclesSolid, IconFrowningFace$1 as IconFrowningFace, IconFrowningFaceSolid$1 as IconFrowningFaceSolid, IconFullCircle$1 as IconFullCircle, IconFullCircleSolid$1 as IconFullCircleSolid, IconFullscreen$1 as IconFullscreen, IconFullscreenExit$1 as IconFullscreenExit, IconGallery$1 as IconGallery, IconGallerySolid$1 as IconGallerySolid, IconGamepad$1 as IconGamepad, IconGamepadSolid$1 as IconGamepadSolid, IconGateway$1 as IconGateway, IconGatewaySolid$1 as IconGatewaySolid, IconGift$1 as IconGift, IconGiftSolid$1 as IconGiftSolid, IconGirl$1 as IconGirl, IconGirlSolid$1 as IconGirlSolid, IconGradeCircle$1 as IconGradeCircle, IconGradeCircleSolid$1 as IconGradeCircleSolid, IconHamburger$1 as IconHamburger, IconHammerSolid$1 as IconHammerSolid, IconHeadphones$1 as IconHeadphones, IconHeadphonesSolid$1 as IconHeadphonesSolid, IconHeart$1 as IconHeart, IconHeartCancel$1 as IconHeartCancel, IconHeartCancelSolid$1 as IconHeartCancelSolid, IconHeartHandshakeSolid$1 as IconHeartHandshakeSolid, IconHeartSolid$1 as IconHeartSolid, IconHeteronymSquare$1 as IconHeteronymSquare, IconHexagonSolid$1 as IconHexagonSolid, IconHierarchy$1 as IconHierarchy, IconHierarchySolid$1 as IconHierarchySolid, IconHighSquare$1 as IconHighSquare, IconHighSquareSolid$1 as IconHighSquareSolid, IconHome$1 as IconHome, IconHomeAltSolid$1 as IconHomeAltSolid, IconHomeSolid$1 as IconHomeSolid, IconHospital$1 as IconHospital, IconHospitalSolid$1 as IconHospitalSolid, IconHourglass$1 as IconHourglass, IconHourglassSolid$1 as IconHourglassSolid, IconHouse$1 as IconHouse, IconHouseSolid$1 as IconHouseSolid, IconIdCard$1 as IconIdCard, IconIdCardBack$1 as IconIdCardBack, IconIdCardBackSolid$1 as IconIdCardBackSolid, IconIdCardSolid$1 as IconIdCardSolid, IconIdCircle$1 as IconIdCircle, IconIdSquare$1 as IconIdSquare, IconImage$1 as IconImage, IconImageAdd$1 as IconImageAdd, IconImageDesktopSolid$1 as IconImageDesktopSolid, IconImageSolid$1 as IconImageSolid, IconImageStar$1 as IconImageStar, IconImageStarSolid$1 as IconImageStarSolid, IconImageUpload$1 as IconImageUpload, IconImport$1 as IconImport, IconIndent$1 as IconIndent, IconInfoCircle$1 as IconInfoCircle, IconInfoCircleSolid$1 as IconInfoCircleSolid, IconInfoflow$1 as IconInfoflow, IconIntelligence$1 as IconIntelligence, IconIntelligenceSolid$1 as IconIntelligenceSolid, IconIntelligentPrompt$1 as IconIntelligentPrompt, IconInvoice$1 as IconInvoice, IconInvoiceSolid$1 as IconInvoiceSolid, IconItalic$1 as IconItalic, IconKeyCommand$1 as IconKeyCommand, IconKeyDelete$1 as IconKeyDelete, IconKeyShift$1 as IconKeyShift, IconKeyboard$1 as IconKeyboard, IconLandingPageSolid$1 as IconLandingPageSolid, IconLayer$1 as IconLayer, IconLayerSolid$1 as IconLayerSolid, IconLayout$1 as IconLayout, IconLayoutSolid$1 as IconLayoutSolid, IconLetterSpacing$1 as IconLetterSpacing, IconLightning$1 as IconLightning, IconLightningSolid$1 as IconLightningSolid, IconLineChart$1 as IconLineChart, IconLineChartAlt$1 as IconLineChartAlt, IconLineChartAltSolid$1 as IconLineChartAltSolid, IconLineChartSolid$1 as IconLineChartSolid, IconLineHeight$1 as IconLineHeight, IconLink$1 as IconLink, IconLinkAlt$1 as IconLinkAlt, IconLinkAltSolid$1 as IconLinkAltSolid, IconListChecked$1 as IconListChecked, IconListOrdered$1 as IconListOrdered, IconListUnordered$1 as IconListUnordered, IconLoading$1 as IconLoading, IconLocation$1 as IconLocation, IconLocationCopy$1 as IconLocationCopy, IconLocationCopySolid$1 as IconLocationCopySolid, IconLocationPin$1 as IconLocationPin, IconLocationPinSolid$1 as IconLocationPinSolid, IconLocationSolid$1 as IconLocationSolid, IconLock$1 as IconLock, IconLockSolid$1 as IconLockSolid, IconLongVideo$1 as IconLongVideo, IconLongVideoSolid$1 as IconLongVideoSolid, IconLowSquare$1 as IconLowSquare, IconLowSquareSolid$1 as IconLowSquareSolid, IconMagicWand$1 as IconMagicWand, IconMagicWandSolid$1 as IconMagicWandSolid, IconMagnet$1 as IconMagnet, IconMagnetSolid$1 as IconMagnetSolid, IconMarket$1 as IconMarket, IconMarketSolid$1 as IconMarketSolid, IconMediaAdd$1 as IconMediaAdd, IconMedicalKit$1 as IconMedicalKit, IconMedicalKitSolid$1 as IconMedicalKitSolid, IconMediumSquare$1 as IconMediumSquare, IconMediumSquareSolid$1 as IconMediumSquareSolid, IconMenu$1 as IconMenu, IconMigrate$1 as IconMigrate, IconMigrateSolid$1 as IconMigrateSolid, IconMiniAppBaidu$1 as IconMiniAppBaidu, IconMiniAppBaiduSolid$1 as IconMiniAppBaiduSolid, IconMiniAppWechat$1 as IconMiniAppWechat, IconMinimize$1 as IconMinimize, IconMinus$1 as IconMinus, IconMinusCircle$1 as IconMinusCircle, IconMinusCircleSolid$1 as IconMinusCircleSolid, IconMobileApp$1 as IconMobileApp, IconMobileAppSolid$1 as IconMobileAppSolid, IconMotionGraphics$1 as IconMotionGraphics, IconMove$1 as IconMove, IconMovieSolid$1 as IconMovieSolid, IconMusic$1 as IconMusic, IconMusicSolid$1 as IconMusicSolid, IconMute$1 as IconMute, IconMuteSolid$1 as IconMuteSolid, IconNeutralFace$1 as IconNeutralFace, IconNeutralFaceSolid$1 as IconNeutralFaceSolid, IconOneToOne$1 as IconOneToOne, IconOneToOneSolid$1 as IconOneToOneSolid, IconOrder$1 as IconOrder, IconOrderSolid$1 as IconOrderSolid, IconOutdent$1 as IconOutdent, IconOutstanding$1 as IconOutstanding, IconOutstandingSolid$1 as IconOutstandingSolid, IconPackageUpload$1 as IconPackageUpload, IconPackageUploadSolid$1 as IconPackageUploadSolid, IconPaintBucket$1 as IconPaintBucket, IconPaintBucketSolid$1 as IconPaintBucketSolid, IconPaperClip$1 as IconPaperClip, IconPaperPlane$1 as IconPaperPlane, IconPaperPlaneSend$1 as IconPaperPlaneSend, IconPaperPlaneSendSolid$1 as IconPaperPlaneSendSolid, IconPaperPlaneSolid$1 as IconPaperPlaneSolid, IconPaste$1 as IconPaste, IconPasteImageSolid$1 as IconPasteImageSolid, IconPasteSolid$1 as IconPasteSolid, IconPath$1 as IconPath, IconPathSolid$1 as IconPathSolid, IconPause$1 as IconPause, IconPauseCircle$1 as IconPauseCircle, IconPauseCircleSolid$1 as IconPauseCircleSolid, IconPenWrite$1 as IconPenWrite, IconPenWriteSolid$1 as IconPenWriteSolid, IconPencil$1 as IconPencil, IconPencilSolid$1 as IconPencilSolid, IconPhone$1 as IconPhone, IconPhoneCall$1 as IconPhoneCall, IconPhoneCallSolid$1 as IconPhoneCallSolid, IconPhoneEye$1 as IconPhoneEye, IconPhoneEyeSolid$1 as IconPhoneEyeSolid, IconPhoneSolid$1 as IconPhoneSolid, IconPieChart$1 as IconPieChart, IconPieChartSolid$1 as IconPieChartSolid, IconPinSlant$1 as IconPinSlant, IconPinSolid$1 as IconPinSolid, IconPlay$1 as IconPlay, IconPlayCircle$1 as IconPlayCircle, IconPlayCircleSolid$1 as IconPlayCircleSolid, IconPlus$1 as IconPlus, IconPlusCircle$1 as IconPlusCircle, IconPlusCircleSolid$1 as IconPlusCircleSolid, IconPlusSquare$1 as IconPlusSquare, IconPlusSquareSolid$1 as IconPlusSquareSolid, IconPowerOff$1 as IconPowerOff, IconPrinterSolid$1 as IconPrinterSolid, IconPuzzlePiece$1 as IconPuzzlePiece, IconPuzzlePieceSolid$1 as IconPuzzlePieceSolid, IconPvShield$1 as IconPvShield, IconPvShieldSolid$1 as IconPvShieldSolid, IconQACommentSolid$1 as IconQACommentSolid, IconQrcode$1 as IconQrcode, IconQualityCircle$1 as IconQualityCircle, IconQualityCircleSolid$1 as IconQualityCircleSolid, IconQuestionCircle$1 as IconQuestionCircle, IconQuestionCircleSolid$1 as IconQuestionCircleSolid, IconQuestionComment$1 as IconQuestionComment, IconQuestionCommentSolid$1 as IconQuestionCommentSolid, IconRecommendSquare$1 as IconRecommendSquare, IconRecommendSquareSolid$1 as IconRecommendSquareSolid, IconRecommendation$1 as IconRecommendation, IconRedo$1 as IconRedo, IconRedoSolid$1 as IconRedoSolid, IconReport$1 as IconReport, IconReportBookmark$1 as IconReportBookmark, IconReportBookmarkSolid$1 as IconReportBookmarkSolid, IconReportCheck$1 as IconReportCheck, IconReportCheckSolid$1 as IconReportCheckSolid, IconReportSearch$1 as IconReportSearch, IconReportSearchSolid$1 as IconReportSearchSolid, IconReportSettings$1 as IconReportSettings, IconReportSettingsSolid$1 as IconReportSettingsSolid, IconReportSolid$1 as IconReportSolid, IconReportStamp$1 as IconReportStamp, IconReportStampSolid$1 as IconReportStampSolid, IconReportStar$1 as IconReportStar, IconReportStarSolid$1 as IconReportStarSolid, IconReportTrendSettings$1 as IconReportTrendSettings, IconReportTrendSettingsSolid$1 as IconReportTrendSettingsSolid, IconReportUser$1 as IconReportUser, IconReportUserSolid$1 as IconReportUserSolid, IconRoad$1 as IconRoad, IconRocketSolid$1 as IconRocketSolid, IconRotateAnticlockwise$1 as IconRotateAnticlockwise, IconRotateAnticlockwiseSolid$1 as IconRotateAnticlockwiseSolid, IconRotateClockwise$1 as IconRotateClockwise, IconRotateClockwiseSolid$1 as IconRotateClockwiseSolid, IconSave$1 as IconSave, IconSaveSolid$1 as IconSaveSolid, IconScan$1 as IconScan, IconSearch$1 as IconSearch, IconSearchDesktop$1 as IconSearchDesktop, IconSearchDesktopSolid$1 as IconSearchDesktopSolid, IconSearchHistory$1 as IconSearchHistory, IconSearchHistorySolid$1 as IconSearchHistorySolid, IconSearchSolid$1 as IconSearchSolid, IconSettings$1 as IconSettings, IconSettingsSolid$1 as IconSettingsSolid, IconShare$1 as IconShare, IconShareAlt$1 as IconShareAlt, IconShareAltSolid$1 as IconShareAltSolid, IconShieldCheck$1 as IconShieldCheck, IconShieldCheckSolid$1 as IconShieldCheckSolid, IconShieldCnySolid$1 as IconShieldCnySolid, IconShieldEllipsisSolid$1 as IconShieldEllipsisSolid, IconShieldTimesSolid$1 as IconShieldTimesSolid, IconShieldUser$1 as IconShieldUser, IconShieldUserSolid$1 as IconShieldUserSolid, IconShieldWave$1 as IconShieldWave, IconShieldWaveSolid$1 as IconShieldWaveSolid, IconShoppingBag$1 as IconShoppingBag, IconShoppingBagSolid$1 as IconShoppingBagSolid, IconShoppingCart$1 as IconShoppingCart, IconShoppingCartSolid$1 as IconShoppingCartSolid, IconShortVideo$1 as IconShortVideo, IconShortVideoSolid$1 as IconShortVideoSolid, IconShrink$1 as IconShrink, IconSignOut$1 as IconSignOut, IconSkipBackward$1 as IconSkipBackward, IconSkipForward$1 as IconSkipForward, IconSlidersSquare$1 as IconSlidersSquare, IconSlidersSquareSolid$1 as IconSlidersSquareSolid, IconSmiley$1 as IconSmiley, IconSmileyComment$1 as IconSmileyComment, IconSmileySolid$1 as IconSmileySolid, IconSmileyStar$1 as IconSmileyStar, IconSmileyStarSolid$1 as IconSmileyStarSolid, IconSort$1 as IconSort, IconSortAlt$1 as IconSortAlt, IconSortAsc$1 as IconSortAsc, IconSortDesc$1 as IconSortDesc, IconSoundWave$1 as IconSoundWave, IconSparklesSolid$1 as IconSparklesSolid, IconSplit$1 as IconSplit, IconSquareRotation$1 as IconSquareRotation, IconSquareRotationSolid$1 as IconSquareRotationSolid, IconStamp$1 as IconStamp, IconStampSolid$1 as IconStampSolid, IconStar$1 as IconStar, IconStarDash$1 as IconStarDash, IconStarDashSoild$1 as IconStarDashSoild, IconStarDashSolid$1 as IconStarDashSolid, IconStarHalf$1 as IconStarHalf, IconStarSolid$1 as IconStarSolid, IconStop$1 as IconStop, IconStopSolid$1 as IconStopSolid, IconStrikethrough$1 as IconStrikethrough, IconSwitch$1 as IconSwitch, IconSync$1 as IconSync, IconSyncCircle$1 as IconSyncCircle, IconSyringe$1 as IconSyringe, IconSyringesSolid$1 as IconSyringesSolid, IconTag$1 as IconTag, IconTagSolid$1 as IconTagSolid, IconTeam$1 as IconTeam, IconTeamSolid$1 as IconTeamSolid, IconTelephone$1 as IconTelephone, IconTelephoneSolid$1 as IconTelephoneSolid, IconTemplate$1 as IconTemplate, IconTemplateSolid$1 as IconTemplateSolid, IconTextFlowerSquare$1 as IconTextFlowerSquare, IconTextFlowerSquareSolid$1 as IconTextFlowerSquareSolid, IconTextSquare$1 as IconTextSquare, IconTextSquareAltSolid$1 as IconTextSquareAltSolid, IconTextSquareSolid$1 as IconTextSquareSolid, IconThumbDown$1 as IconThumbDown, IconThumbDownSolid$1 as IconThumbDownSolid, IconThumbUp$1 as IconThumbUp, IconThumbUpSolid$1 as IconThumbUpSolid, IconTimes$1 as IconTimes, IconTimesCircle$1 as IconTimesCircle, IconTimesCircleSolid$1 as IconTimesCircleSolid, IconToolbox$1 as IconToolbox, IconToolboxSolid$1 as IconToolboxSolid, IconToolsSolid$1 as IconToolsSolid, IconTrackCut$1 as IconTrackCut, IconTrackFrameLast$1 as IconTrackFrameLast, IconTrash$1 as IconTrash, IconTrashSolid$1 as IconTrashSolid, IconTravelEarthPlaneSolid$1 as IconTravelEarthPlaneSolid, IconTreasureChest$1 as IconTreasureChest, IconTreasureChestSolid$1 as IconTreasureChestSolid, IconTrendDesktop$1 as IconTrendDesktop, IconTrendDesktopSolid$1 as IconTrendDesktopSolid, IconTrendMonitor$1 as IconTrendMonitor, IconTrendMonitorSolid$1 as IconTrendMonitorSolid, IconTrendPages$1 as IconTrendPages, IconTrendPagesSolid$1 as IconTrendPagesSolid, IconTrendReport$1 as IconTrendReport, IconTrendReportSolid$1 as IconTrendReportSolid, IconTrendStarSolid$1 as IconTrendStarSolid, IconTrimLeft$1 as IconTrimLeft, IconTrimRight$1 as IconTrimRight, IconTrophy$1 as IconTrophy, IconTrophySolid$1 as IconTrophySolid, IconTruck$1 as IconTruck, IconTruckSolid$1 as IconTruckSolid, IconTv$1 as IconTv, IconTvSolid$1 as IconTvSolid, IconTwoHearts$1 as IconTwoHearts, IconTwoHeartsSolid$1 as IconTwoHeartsSolid, IconUnderline$1 as IconUnderline, IconUndo$1 as IconUndo, IconUndoSolid$1 as IconUndoSolid, IconUnlink$1 as IconUnlink, IconUnlock$1 as IconUnlock, IconUnlockSolid$1 as IconUnlockSolid, IconUpdateWave$1 as IconUpdateWave, IconUpgrade$1 as IconUpgrade, IconUpgradeSolid$1 as IconUpgradeSolid, IconUpload$1 as IconUpload, IconUploadDesktop$1 as IconUploadDesktop, IconUploadDesktopSolid$1 as IconUploadDesktopSolid, IconUser$1 as IconUser, IconUserAuthorization$1 as IconUserAuthorization, IconUserBookmark$1 as IconUserBookmark, IconUserBookmarkSolid$1 as IconUserBookmarkSolid, IconUserCard$1 as IconUserCard, IconUserCardSolid$1 as IconUserCardSolid, IconUserCircle$1 as IconUserCircle, IconUserCircleSolid$1 as IconUserCircleSolid, IconUserCombined$1 as IconUserCombined, IconUserCombinedSolid$1 as IconUserCombinedSolid, IconUserFilter$1 as IconUserFilter, IconUserFilterSolid$1 as IconUserFilterSolid, IconUserIntersection$1 as IconUserIntersection, IconUserIntersectionSolid$1 as IconUserIntersectionSolid, IconUserLabel$1 as IconUserLabel, IconUserLabelSolid$1 as IconUserLabelSolid, IconUserMobile$1 as IconUserMobile, IconUserMobileSolid$1 as IconUserMobileSolid, IconUserSearch$1 as IconUserSearch, IconUserSearchSolid$1 as IconUserSearchSolid, IconUserSettings$1 as IconUserSettings, IconUserSettingsSolid$1 as IconUserSettingsSolid, IconUserSolid$1 as IconUserSolid, IconUserStar$1 as IconUserStar, IconUserSync$1 as IconUserSync, IconUserSyncSolid$1 as IconUserSyncSolid, IconUserTieba$1 as IconUserTieba, IconVideo$1 as IconVideo, IconVideoAdd$1 as IconVideoAdd, IconVideoCrop$1 as IconVideoCrop, IconVideoCropSolid$1 as IconVideoCropSolid, IconVideoFilm$1 as IconVideoFilm, IconVideoFilmSolid$1 as IconVideoFilmSolid, IconVideoFrameFirst$1 as IconVideoFrameFirst, IconVideoHistory$1 as IconVideoHistory, IconVideoHistorySolid$1 as IconVideoHistorySolid, IconVideoSolid$1 as IconVideoSolid, IconVideoUpload$1 as IconVideoUpload, IconVolume$1 as IconVolume, IconVolumeSolid$1 as IconVolumeSolid, IconWhirlpool$1 as IconWhirlpool, IconWhirlpoolSolid$1 as IconWhirlpoolSolid, IconWoman$1 as IconWoman, IconYaoSquare$1 as IconYaoSquare, IconYingxiaotong$1 as IconYingxiaotong, IconYingxiaotongSolid$1 as IconYingxiaotongSolid, IconZoomIn$1 as IconZoomIn, IconZoomInSolid$1 as IconZoomInSolid, IconZoomOut$1 as IconZoomOut, IconZoomOutSolid$1 as IconZoomOutSolid, SharedResources, createIcon };
//# sourceMappingURL=index.js.map
